import jq from 'jquery';
import { cookieBase, cdnUrls } from 'server-data/flconfigs';
import { oneLine, oneLineTrim } from 'common-tags';
import 'css/flux/modules/Modal.less';
import 'bootstrap';
import _ from 'underscore';
import 'jquery-validate';
import videojs from 'video-js';
import { user, contest, entry, messagesData, isLoggedIn, isEntryLiked, loginUrl, siteUrl, loggedInUser, infractionTypes } from 'server-data/contest-multitype-fullview';
import 'jquery-star-rating';
import 'jquery-star-rating/index.css';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'video-js/dist/video-js.css';

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

function processEvent(event) {
  var eventName = event.event;
  if (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
  if (eventName == 'NonHireMe Posted') {
    _ttref.push(['_trackEvent', 'PostProject', 'Posted']);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_PostProjectForm']);
  } else if (eventName == 'Buy Exam') {
    _ttref.push(['_trackEvent', 'Exams', 'ConfirmBuy', event.examName]);
  } else if (eventName == 'Bid on Project') {
    _ttref.push(['_trackEvent', 'Project', 'Bid', '', 0, true, true]);
    qtsp.push({
      label: 'PlaceBid',
      amount: event.amount,
      currency: event.currency
    });
  } else if (eventName == 'Contest Reposted') {
    _ttref.push(['_setEntrypoint', 'Contest_RepostSuccessContest']);
  } else if (eventName == 'Entries Submitted') {
    // track the submitted entries from dropdown notification
    if (event.xp_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'XP Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
    if (event.realtime_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'Realtime Notification Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
  } else if (eventName == 'Suggestion Click') {
    _t.push(['project_suggestion_redirect', {
      bidder_id: event.bidder_id,
      src_project_id: event.src_project_id,
      dst_project_id: event.dst_project_id,
      time: new Date()
    }]);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_Suggestion']);
    _ttref.push(['_trackEvent', 'Project', 'Suggestion', 'clicked', 0, false, true]);
  } else if (eventName == 'Service View') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'ViewPage',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Modal Cancel') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModalCancel',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Button Click') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderButton',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Confirm Modal') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModal',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Button Click Logged Out') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderButtonLoggedOut',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Payment Verified') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderModalOkPaymentVerified',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Modal Purchase') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderModalOkPurchase',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Modal Ok') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModalOk',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal Login') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'Login',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal FB Login') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'FBLogin',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal Sign Up') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'SignUp',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Deposit') {
    _t.push(['user_action', {
      section: 'ServiceDepositPage',
      label: 'OrderDepositPage',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Deposit Success') {
    _t.push(['user_action', {
      section: 'ServiceProjectPage',
      label: 'ServicePurchasedFromDeposit',
      action: 'view'
    }]);
  } else if (eventName == 'Dashboard MyProjects') {
    _t.push(['user_action', {
      section: 'Dashboard',
      subsection: 'Topnav',
      label: 'MyProjects'
    }]);
  } else if (eventName == 'Service Order Deposit Other Methods') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderDepositModal',
      label: 'OrderDepositOtherMethods',
      action: 'view'
    }]);
  } else if (eventName == 'Showcase Upsell PVP') {
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_ShowcaseUpsell']);

    _t.push(['user_action', {
      section: 'ProjectShowcaseUpsell',
      subsection: 'RepostButton',
      label: event.source,
      action: 'click'
    }]);
  } else if (eventName == 'Front Page Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'FrontPageUpperRight',
      action: 'click'
    }]);
  } else if (eventName == 'Post Project Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'PostProjectPage',
      action: 'click'
    }]);
  } else if (eventName == 'Post Contest Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'PostContestPage',
      action: 'click'
    }]);
  } else if (eventName == 'Top Right Corner') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'TopRightCorner',
      action: 'click'
    }]);
  } else if (eventName == 'Hire Me Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'HireMePage',
      action: 'click'
    }]);
  } else if (eventName == 'User Login Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'UserLogInPage',
      action: 'click'
    }]);
  } else if (eventName == 'Repost Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'RepostPage',
      action: 'click'
    }]);
  } else if (eventName == 'Sign Up Modal') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'SignUpModal',
      action: 'click'
    }]);
  } else if (eventName == 'Find Freelancers Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'FindFreelancersPage',
      action: 'click'
    }]);
  } else if (eventName == 'Directory Page Search') {
    _t.push(['search', {
      section: 'Directory',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page
    }]);
  } else if (eventName == 'Navigation Bar Search') {
    _t.push(['search', {
      section: 'MainNav',
      keyword: event.keyword
    }]);
  } else if (eventName == 'Jobs Page Search') {
    _t.push(['search', {
      section: 'JobTable',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page,
      sort: event.sort
    }]);
  } else if (eventName == 'Work Search') {
    _t.push(['search', {
      section: 'WorkTable',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page,
      sort: event.sort
    }]);
  } else if (eventName == 'Project View Page - Upsell Banner') {
    _t.push(['user_action', {
      section: 'ProjectViewPage',
      subsection: event.eventOption.subsection,
      label: event.eventOption.label,
      action: event.eventOption.action
    }]);
  } else if (eventName === 'Project View Page - Bid on this project') {
    _t.push(['user_action', {
      section: 'Project',
      sub_section: 'BidTheProject',
      label: event.label
    }]);
  } else {
    _t.push(event);
  }
}

function LocalTracking() {
  this._events = [];
}

LocalTracking.prototype._save = function () {
  try {
    localStorage.setItem('LocalTracking', JSON.stringify(this._events));
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._restore = function () {
  try {
    var events = JSON.parse(localStorage.getItem('LocalTracking'));
    for (var _i = 0, _len = events.length; _i < _len; _i++) {
      this.push(events[_i]);
    }
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._process = function () {
  var events = this._events;
  this._events = [];
  for (var _i = 0, _len = events.length; _i < _len; _i++) {
    processEvent(events[_i]);
  }
  try {
    localStorage.removeItem('LocalTracking');
  } catch (e) {
    return false;
  }
  return true;
};

LocalTracking.prototype.push = function (event, options) {
  var delay = 5000;

  if (typeof options === 'object') {
    delay = options.delay ? options.delay : delay;
  }

  this._events.push(event);
  this._save();
  var self = this;
  setTimeout(function () {
    self._process();
  }, delay);
  return 1;
};

LocalTracking.prototype.init = function (_t) {
  var event = void 0;
  var _i = void 0;
  var _len = void 0;
  this._restore();
  if (_t == null) {
    _t = [];
  }
  for (_i = 0, _len = _t.length; _i < _len; _i++) {
    event = _t[_i];
    this.push(event);
  }
  return this;
};

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function getUserIdfromCookie() {
  return getCookie(cookieBase + '_USER_ID');
}

// DEPRECATED. Just use cookieBase from 'server-data/flconfigs'
// const getCookieBase;

function getAuthHeader() {
  var authHashV2 = getCookie(cookieBase + '_AUTH_HASH_V2');
  var userId = getUserIdfromCookie();
  return { 'Freelancer-Auth-V2': userId + ';' + authHashV2 };
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

// Compute the CRC32 of a string
var table = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

/* Number */
function crc32( /* String */str, /* Number */crc) {
  if (crc == undefined) crc = 0;
  var n = 0; // a number between 0 and 255
  var x = 0; // an hex number

  crc ^= -1;
  for (var i = 0, iTop = str.length; i < iTop; i++) {
    n = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(n * 9, 8);
    crc = crc >>> 8 ^ x;
  }
  return crc ^ -1;
}

function cdn_url(url, protocol) {
  // forcing https this way for backwards compat
  protocol = 'https://';

  var host = cdnUrls[Math.abs(crc32(url)) % cdnUrls.length];
  return protocol + host + url;
}

function request(url, opts) {
  var defaultOptions = {
    credentials: 'same-origin', // allow cookies to be sent
    headers: new Headers({
      'X-XSRF-TOKEN': getCSRFToken() })
  };

  var options = Object.assign({}, defaultOptions, opts);

  return fetch(url, options).then(function (response) {
    return response.json();
  });
}

function JsonToQueryString(json) {
  return Object.keys(json).map(function (key) {
    if (key.search(/\[\]/) !== -1 && json[key] instanceof Array) {
      return ArrayToQueryString(json[key], key);
    }

    var k = encodeURIComponent(key);
    var v = encodeURIComponent(json[key]);
    return k + '=' + v;
  }).join('&');
}

function ArrayToQueryString(arr, key) {
  var k = encodeURIComponent(key);
  return arr.map(function (value) {
    var v = encodeURIComponent(value);
    return k + '=' + v;
  }).join('&');
}

function JsonToFormData(json) {
  var data = new FormData();

  Object.keys(json).forEach(function (key) {
    data.append(key, json[key]);
  });

  return data;
}

function doPOSTRequest(url, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var defaultOptions = {
    method: 'POST',
    body: JsonToFormData(data)
  };

  var options = Object.assign({}, defaultOptions, opts);
  return request(url, options);
}

function doPOSTRequestUsingFormData(url, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var defaultOptions = {
    method: 'POST',
    body: data
  };

  var options = Object.assign({}, defaultOptions, opts);
  return request(url, options);
}

function doGETRequest(url, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var queryString = JsonToQueryString(data);
  var requestUrl = url + '?' + queryString;

  var defaultOptions = {
    method: 'GET'
  };

  var options = Object.assign({}, defaultOptions, opts);
  return request(requestUrl, options);
}

var _templateObject = _taggedTemplateLiteral(['/ajax/contest/projectAction/\n      getContestsInterestedIn.php'], ['/ajax/contest/projectAction/\n      getContestsInterestedIn.php']);

var ContestApi = function () {
  function ContestApi() {
    _classCallCheck(this, ContestApi);
  }

  _createClass(ContestApi, [{
    key: 'getContestHolderReputation',
    value: function getContestHolderReputation(data) {
      return doGETRequest('/ajax/reputation-employer-on-hover-content.php', data);
    }
  }, {
    key: 'getUsersPlanToJoin',
    value: function getUsersPlanToJoin(data) {
      return doGETRequest('/ajax/contest/projectAction/getContestJoins.php', data);
    }
  }, {
    key: 'joinContest',
    value: function joinContest(data) {
      return doPOSTRequest('/ajax/contest/projectAction/joinContest.php', data);
    }
  }, {
    key: 'bookMark',
    value: function bookMark(data) {
      return doPOSTRequest('/ajax/contest/watch.php', data);
    }
  }, {
    key: 'upgradeContest',
    value: function upgradeContest(data) {
      return doPOSTRequest('/ajax/contest/update.php', data);
    }
  }, {
    key: 'getExtendFees',
    value: function getExtendFees(data) {
      return doPOSTRequest('/ajax/contest/projectAction/getExtendedFees.php', data);
    }
  }, {
    key: 'getUserPaymentMethodInfo',
    value: function getUserPaymentMethodInfo(data) {
      return doPOSTRequest('/ajax/payment/getUserPaymentMethodInfo.php', data);
    }
  }, {
    key: 'getFirstWinner',
    value: function getFirstWinner(data) {
      return doGETRequest('/ajax/contest/projectAction/getFirstWinner.php', data);
    }
  }, {
    key: 'getEngagementData',
    value: function getEngagementData(data) {
      return doGETRequest('/ajax/contest/getEngagementData.php', data);
    }
  }, {
    key: 'getContestsInterestedIn',
    value: function getContestsInterestedIn(data) {
      return doGETRequest(oneLineTrim(_templateObject), data);
    }
  }, {
    key: 'unlockEntries',
    value: function unlockEntries(data) {
      return doGETRequest('/ajax/contest/projectAction/unlockEntries.php', data);
    }
  }, {
    key: 'pollVote',
    value: function pollVote(data) {
      return doPOSTRequest('/ajax/contest/pollVote.php', data);
    }
  }, {
    key: 'getContestEntryRequirements',
    value: function getContestEntryRequirements(data) {
      return doGETRequest('/ajax-api/contests/getContestEntryRequirements.php', data, {
        headers: getAuthHeader()
      });
    }
  }]);

  return ContestApi;
}();

var _templateObject$1 = _taggedTemplateLiteral(['/ajax/contest/projectAction/\n      getExtendBannerEligibility.php'], ['/ajax/contest/projectAction/\n      getExtendBannerEligibility.php']);

var EntryApi = function () {
  function EntryApi() {
    _classCallCheck(this, EntryApi);
  }

  _createClass(EntryApi, [{
    key: 'getEntries',
    value: function getEntries(data) {
      return doPOSTRequest('/ajax/contest/projectAction/getEntries.php', data);
    }
  }, {
    key: 'highlight',
    value: function highlight(data) {
      return doPOSTRequest('/ajax/contest/highlightEntry.php', data);
    }
  }, {
    key: 'getWinnerEntries',
    value: function getWinnerEntries(data) {
      return doGETRequest('/ajax/contest/projectAction/getWinnerEntries.php', data);
    }
  }, {
    key: 'getPendingHandoverEntries',
    value: function getPendingHandoverEntries(data) {
      return doGETRequest('/ajax/contest/projectAction/getPendingHandover.php', data);
    }
  }, {
    key: 'rate',
    value: function rate(data) {
      return doPOSTRequest('/ajax/contest/projectAction/rate.php', data);
    }
  }, {
    key: 'toggleLike',
    value: function toggleLike(data) {
      return doPOSTRequest('/ajax/contest/projectAction/toggleEntryLike.php', data);
    }
  }, {
    key: 'reject',
    value: function reject(data) {
      var requestData = Object.assign({}, data, {
        action: 'do'
      });
      return doPOSTRequest('/ajax/contest/projectAction/eliminate.php', requestData);
    }
  }, {
    key: 'reconsider',
    value: function reconsider(data) {
      var requestData = Object.assign({}, data, {
        action: 'undo'
      });
      return doPOSTRequest('/ajax/contest/projectAction/eliminate.php', requestData);
    }
  }, {
    key: 'award',
    value: function award(data) {
      return doPOSTRequest('/ajax/contest/projectAction/pick.php', data);
    }
  }, {
    key: 'withdraw',
    value: function withdraw(data) {
      var requestData = Object.assign({}, data, {
        action: 'do'
      });
      return doGETRequest('/ajax/contest/projectAction/withdraw.php', requestData);
    }
  }, {
    key: 'resubmit',
    value: function resubmit(data) {
      var requestData = Object.assign({}, data, {
        action: 'undo'
      });
      return doGETRequest('/ajax/contest/projectAction/withdraw.php', requestData);
    }
  }, {
    key: 'submit',
    value: function submit(data) {
      return doPOSTRequestUsingFormData('/ajax/contest/ajaxAddEntry.php', data);
    }
  }, {
    key: 'replaceFiles',
    value: function replaceFiles(entryId, fileNames) {
      var headers = new Headers(getAuthHeader());
      headers.append('Content-Type', 'application/json');

      return fetch('/api/contests/0.1/entries/' + entryId + '/files/', {
        method: 'PUT',
        body: JSON.stringify({
          file_names: fileNames
        }),
        headers: headers
      }).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: 'getExtendBannerEligibility',
    value: function getExtendBannerEligibility(data) {
      return doGETRequest(oneLineTrim(_templateObject$1), data);
    }
  }, {
    key: 'buy',
    value: function buy(data) {
      return doPOSTRequest('/ajax/contest/projectAction/buy.php', data);
    }
  }, {
    key: 'editEntryPrice',
    value: function editEntryPrice(data) {
      return doPOSTRequest('/ajax/contest/editEntryPrice.php', data);
    }
  }, {
    key: 'getEntryIds',
    value: function getEntryIds(data) {
      return doGETRequest('/ajax/contest/projectAction/getEntryIds.php', data);
    }
  }, {
    key: 'getEntryInfo',
    value: function getEntryInfo(data) {
      return doGETRequest('/ajax/contest/projectAction/getEntryInfo.php', data);
    }
  }, {
    key: 'sendUserVerificationEmail',
    value: function sendUserVerificationEmail(data) {
      return doPOSTRequest('/users/resendcode.php', data);
    }
  }, {
    key: 'makeEntryPriceOffer',
    value: function makeEntryPriceOffer(data) {
      return doPOSTRequest('/ajax/contest/createEntryPriceOffer.php', data);
    }
  }, {
    key: 'acceptEntryPriceOffer',
    value: function acceptEntryPriceOffer(data) {
      return doPOSTRequest('/ajax/contest/acceptEntryPriceOffer.php', data);
    }
  }]);

  return EntryApi;
}();

var MessageApi = function () {
  function MessageApi() {
    _classCallCheck(this, MessageApi);
  }

  _createClass(MessageApi, [{
    key: 'getMessages',
    value: function getMessages(data) {
      return doGETRequest('/ajax/contest/projectAction/getMessages.php', data);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(data) {
      return doPOSTRequest('/ajax/contest/projectAction/postMessage.php', data);
    }
  }, {
    key: 'deleteMessage',
    value: function deleteMessage(data) {
      var param = Object.assign({}, data, {
        action: 'delete'
      });
      return doPOSTRequest('/ajax/contest/projectAction/moderateMessage.php', param);
    }
  }, {
    key: 'updateMessage',
    value: function updateMessage(data) {
      return doPOSTRequest('/ajax/contest/updateMessage.php', data);
    }
  }]);

  return MessageApi;
}();

var CollaborationApi = function () {
  function CollaborationApi() {
    _classCallCheck(this, CollaborationApi);
  }

  _createClass(CollaborationApi, [{
    key: 'listCollaborations',
    value: function listCollaborations(data) {
      return doGETRequest('/ajax/contest/listCollaborators.php', data);
    }
  }, {
    key: 'addCollaborator',
    value: function addCollaborator(data) {
      return doPOSTRequest('/ajax/contest/addCollaborator.php', data);
    }
  }, {
    key: 'removeCollaborator',
    value: function removeCollaborator(data) {
      return doPOSTRequest('/ajax/contest/removeCollaborator.php', data);
    }
  }]);

  return CollaborationApi;
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

var template$1 = "<div id=\"<%=  id  %>\" class=\"Modal <%=  extraClass  %>\" data-modal aria-hidden=\"<%=  hideModal  %>\">\n  <div class=\"Modal-inner\" <%  if (backdropClose) {  %> data-modal-outbound <%  }  %>>\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <%  if (closeButton) {  %>\n        <button class=\"Modal-close\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\">\n          <span class=\"Icon Icon--small\"><%=  uiIcon('ui-close')  %></span>\n        </button>\n        <%  }  %>\n        <%  if (header) {  %>\n        <header class=\"Modal-header\">\n          <%=  header  %>\n        </header>\n        <%  }  %>\n        <%  if (body) {  %>\n        <div class=\"Modal-body\">\n          <%=  body  %>\n        </div>\n        <%  }  %>\n        <%  if (footer) {  %>\n        <footer class=\"Modal-footer\">\n          <%=  footer  %>\n        </footer>\n        <%  }  %>\n      </div>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var OPEN_EVENT = {
  METHOD: 'method'
};

var CLOSE_EVENT = {
  ESC: 'esc',
  OUTOFBOUNDS: 'outofbounds',
  ELEMENT: 'element'
};

var defaultOptions = {
  main: document.querySelector('#main'),
  closeButton: true,
  backdropClose: true,
  extraClass: '',
  size: '',
  type: ''
};

// Template the modal's scaffolding by injecting header, body and footer
var scaffold = template(template$1);

/**
 * Modal constructor
 * @param {Node} node Dialog element
 * @param {Node} main Main element of the page
 */

var Modal = function () {
  /**
   * Modal constructor
   * @param  {String}   id                       An ID to apply to the modal.
   * @param  {Object}   content                  Content object to inject in the
   *                                             modal.
   * @param  {String}   content.header           Content for the header.
   * @param  {String}   content.body             Content for the body.
   * @param  {String}   content.footer           Content for the footer.
   * @param  {Object}   [options={}]             Options object for customise
   *                                             behaviour of modal.
   * @param  {Node}     [options.main]           An element to treat as the main
   *                                             content so that
   *                                             aria-hidden="true" can be
   *                                             toggled. Defaults to #main.
   * @param  {Boolean}  [options.closeButton]    Shows the x close button.
   *                                             Defaults to true.
   * @param  {Boolean}  [options.backdropClose]  Enables closing of modal via
   *                                             clicking on the backdrop.
   *                                             Defaults to true.
   * @param  {String}   [options.extraClass]     Adds extra classes to the
   *                                             modal.
   * @param  {String}   [options.size]           Sets the size of the modal.
   * @param  {String}   [options.type]           Sets the type of the modal.
   * @param  {Function} [options.onShow]         Callback function after showing
   *                                             the modal.
   * @param  {Function} [options.onHide]        Callback function after closing
   *                                             the modal.
   * @return {Modal}                             Modal instance.
   */
  function Modal(id, content, opts) {
    _classCallCheck(this, Modal);

    // Merge user options with defaultOptions
    var options = Object.assign({}, defaultOptions, opts);

    // Build configuration
    this.config = {
      id: id,
      content: {
        header: content.header,
        body: content.body,
        footer: content.footer
      },
      options: options
    };

    // Errors
    if (typeof this.config.id === 'undefined') {
      throw new TypeError('Modal id cannot be undefined.');
    }

    if (typeof this.config.content === 'undefined') {
      throw new TypeError('Modal content cannot be undefined.');
    }

    if (typeof this.config.options.main === 'undefined') {
      throw new TypeError('#main element does not exist.');
    }

    this.namespace = 'data-modal';
    this.body = document.body;
    this.main = this.config.options.main;

    // Appends markup to the body just before the </body>
    this.body.insertAdjacentHTML('beforeend', scaffold({
      uiIcon: uiIcon,
      id: this.config.id,
      hideModal: true,
      header: this.config.content.header,
      body: this.config.content.body,
      footer: this.config.content.footer,
      closeButton: this.config.options.closeButton,
      backdropClose: this.config.options.backdropClose,
      extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
    }));

    this.node = document.getElementById(this.config.id);
    this.shown = false;

    this._bindEventsToModal();
    return this;
  }

  /**
   * Helper function that binds modal events to the modal element
   */

  _createClass(Modal, [{
    key: '_bindEventsToModal',
    value: function _bindEventsToModal() {
      var _this = this;

      // Bind show modal event to elements with <this.namespace>-show="<modal-id>"
      // data attributes
      Array.from(
      // Get all the elements with <this.namespace>-show="<modal-id>"
      document.querySelectorAll('[' + this.namespace + '-show="' + this.node.id + '"]')).forEach(function (opener) {
        opener.addEventListener('click', function () {
          return _this.show();
        });
      });

      // Bind hide modal event to elements with <this.namespace>-hide data
      // attributesmodules/membership/index.js
      Array.from(
      // Get all elements with <this.namespace>-hide inside the modal
      this.node.querySelectorAll('[' + this.namespace + '-hide]'))
      // Then combine it with all elements on the page that targets the modal
      // with <this.namespace>-hide="<modal-id>" for hiding
      .concat(Array.from(document.querySelectorAll('[' + this.namespace + '-hide="' + this.node.id + '"]'))).forEach(function (closer) {
        closer.addEventListener('click', function () {
          return _this.hide(CLOSE_EVENT.ELEMENT);
        });
      });

      // Hides modal when the user clicks out of bounds
      this.node.addEventListener('click', function (event) {
        if (event.target.hasAttribute(_this.namespace + '-outbound')) {
          _this.hide(CLOSE_EVENT.OUTOFBOUNDS);
        }
      });

      document.addEventListener('keydown', function (event) {
        // keydown on Esc key
        if (_this.shown && event.which === 27) {
          event.preventDefault();
          _this.hide(CLOSE_EVENT.ESC);
        }

        // keydown on Tab key
        if (_this.shown && event.which === 9) {
          _this._trapTabKey(_this.node, event);
        }
      });

      this.body.addEventListener('focus', function (event) {
        if (_this.shown && !_this.node.contains(event.target)) {
          _this._setFocusToFirstItem(_this.node);
        }
      }, true);
    }

    /**
     * Helper function to get all focusable children from a node
     * @param  {Node} node Node to look in
     * @return {Array}     Array of focusable nodes
     */

  }, {
    key: '_getFocusableChildren',
    value: function _getFocusableChildren(node) {
      var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

      return Array.from(node.querySelectorAll(focusableElements.join(','))).filter(function (child) {
        return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
      });
    }

    /**
     * Helper function trapping the tab key inside a node
     * @param  {Node} node    Node to trap tab key in
     * @param  {Object} event Event to intercept
     */

  }, {
    key: '_trapTabKey',
    value: function _trapTabKey(node, event) {
      var focusableChildren = this._getFocusableChildren(node);
      var focusedItemIndex = focusableChildren.indexOf(document.activeElement);

      if (event.shiftKey && focusedItemIndex === 0) {
        focusableChildren[focusableChildren.length - 1].focus();
        event.preventDefault();
      } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
        focusableChildren[0].focus();
        event.preventDefault();
      }
    }

    /**
     * Helper function to focus first focusable item in node
     * @param {Node} node Node to search in for first focusable
     */

  }, {
    key: '_setFocusToFirstItem',
    value: function _setFocusToFirstItem(node) {
      var focusableChildren = this._getFocusableChildren(node);
      if (focusableChildren.length) focusableChildren[0].focus();
    }

    /**
     * Checks if scrollbar is visible.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_checkScrollbar',
    value: function _checkScrollbar() {
      var fullWindowWidth = window.innerWidth;

      this.bodyIsOverflowing = this.body.clientWidth < fullWindowWidth;
      this.scrollbarWidth = this._measureScrollbar();
    }

    /**
     * Sets the scrollbar padding offset on the body element.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_setScrollbar',
    value: function _setScrollbar() {
      var bodyPadding = parseInt(this.body.style.paddingRight || 0, 10);

      this.originalBodyPadding = this.body.style.paddingRight || '';

      if (this.bodyIsOverflowing) {
        this.body.style.paddingRight = '' + bodyPadding + this.scrollbarWidth + 'px';
      }
    }

    /**
     * Resets the padding on the body to the way it was with the scrollbar.
     * Ported from the bootstrap v3.3.6.
     */

  }, {
    key: '_resetScrollbar',
    value: function _resetScrollbar() {
      this.body.style.paddingRight = this.originalBodyPadding;
    }

    /**
     * Measures the width of the scrollbar.
     * Ported from the bootstrap v3.3.6.
     *
     * @return {Number} Width of the scrollbar.
     */

  }, {
    key: '_measureScrollbar',
    value: function _measureScrollbar() {
      var scrollDiv = document.createElement('div');
      // Injects some styling to the element which forces the display of a scroll
      // bar and places it off the page to ensure it is never visible.
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';

      this.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      this.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }

    /**
     * Show the modal with optional eventType identifier
     * @param  {String} eventType An identifier string to pass into the onShow
     *                            callback method.
     */

  }, {
    key: 'show',
    value: function show(eventType) {
      this.shown = true;
      this._checkScrollbar();
      this._setScrollbar();
      this.body.setAttribute(this.namespace + '-open', '');
      this.node.removeAttribute('aria-hidden');
      this.main.setAttribute('aria-hidden', 'true');
      this.focusedBeforeDialog = document.activeElement;
      this._setFocusToFirstItem(this.node);
      eventType = eventType || OPEN_EVENT.METHOD;

      if (this.config.options.onShow) {
        this.config.options.onShow(eventType);
      }
    }

    /**
     * Hide the modal
     * @param  {String} eventType An identifier string to pass into the onHide
     *                            callback method.
     */

  }, {
    key: 'hide',
    value: function hide(eventType) {
      this.shown = false;
      this._resetScrollbar();
      this.body.removeAttribute(this.namespace + '-open', '');
      this.node.setAttribute('aria-hidden', 'true');
      this.main.removeAttribute('aria-hidden');
      this.focusedBeforeDialog.focus();

      if (this.config.options.onHide) {
        this.config.options.onHide(eventType);
      }
    }

    /**
     * Dynamically change the template of the modal given the new template.
     * Use this if you want to change the content without creating a new modal
     * as this does not automatically hide the new content upon replacement
     *
     * @param  {Object} content Content object to inject in the modal.
     */

  }, {
    key: 'replaceTemplate',
    value: function replaceTemplate(content) {
      var newModalContent = scaffold({
        uiIcon: uiIcon,
        id: this.config.id,
        hideModal: false,
        header: content.header,
        body: content.body,
        footer: content.footer,
        closeButton: this.config.options.closeButton,
        backdropClose: this.config.options.backdropClose,
        extraClass: this.config.options.extraClass + ' ' + (this.config.options.size + ' ') + ('' + this.config.options.type)
      });

      // convert content to nodes
      var newModal = document.createElement('div');
      newModal.innerHTML = newModalContent;
      var newTemplate = newModal.childNodes[0];

      // replace with new template
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(newTemplate.children, function (child) {
        var childNode = child instanceof Node ? child : document.createTextNode(String(child));
        fragment.appendChild(childNode);
      });

      this.node.replaceChild(fragment, this.node.children[0]);

      // bind modal events
      this.node = document.getElementById(this.config.id);
      this._bindEventsToModal();
    }
  }]);

  return Modal;
}();

var infractionFormHeaderTemplate = "<div class=\"Card-header InfractionsModal-header\">\n  <h3><%=  title  %></h3>\n</div>\n";

var infractionFormBodyTemplate = "<div class=\"Card-body InfractionsModal-body\">\n  <form class=\"fl-form InfractionsModal-form\">\n      <legend><%=  bodyTitle  %></legend>\n\n      <%  if (error) {  %>\n        <div class=\"alert alert-error \">\n          <span class=\"Icon InfractionsModal-icon--error\">\n              <%=  uiIcon('ui-warning')  %>\n          </span>\n          <strong><%- T_('Si è verificato un errore.') %></strong>\n          <span><%- T_('Riprova per piacere.') %></span>\n        </div>\n      <%  }  %>\n\n    <fieldset>\n      <ol>\n        <li class=\"form-step\">\n          <%  if (options.length > 0) {  %>\n            <div class=\"Radio Radio--vertical InfractionsModal-options\">\n              <%  options.forEach(function(option) {  %>\n                <input\n                  id=\"infraction-<%=  option.id  %>\"\n                  class=\"Radio-input InfractionsModal-option\"\n                  type=\"radio\"\n                  name=\"<%=  optionName  %>\"\n                  value=\"<%=  option.id  %>\"\n                  <%  if (option.id === category || option.id === violation) {  %>\n                    checked\n                  <%  }  %>\n                  >\n                <label class=\"Radio-label InfractionsModal-option-label\" for=\"infraction-<%=  option.id  %>\">\n                  <%=  option.type  %>\n                </label>\n              <%  });  %>\n            </div>\n          <%  } else {  %>\n            <textarea\n              class=\"default-textarea InfractionsModal-comments\"\n              placeholder=\"<%=  textAreaPlaceholder  %>\"\n              cols=\"50\"\n              rows=\"5\"\n            ><%=  comments  %></textarea>\n          <%  }  %>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var infractionFormFooterTemplate = "<div class=\"Card-footer--simple InfractionsModal-footer\">\n  <%  if ((optionName && optionName == 'infractionCategory') || (optionName && optionName === 'infractionType' && defaultInfractionCategory)) {  %>\n    <button type=\"button\" class=\"btn\" data-modal-hide><%- T_('Annulla') %></button>\n  <%  } else {  %>\n    <button type=\"button\" class=\"btn InfractionsModal-back\"><%- T_('Indietro') %></button>\n  <%  }  %>\n\n  <button\n    type=\"button\"\n    class=\"btn btn-info InfractionsModal-next\"\n    <%  if (disableNext) {  %>\n      disabled\n    <%  }  %>\n    >\n    <%- T_('Continua') %>\n  </button>\n</div>\n";

var infractionSuccessHeaderTemplate = "<div class=\"Card-header InfractionsModal-header\">\n  <h3><%=  title  %></h3>\n</div>\n";

var infractionSuccessBodyTemplate = "<div class=\"Card-body InfractionsModal-body\">\n  <h5><%=  bodyTitle  %></h5>\n  <p><%=  body  %></p>\n</div>\n";

var infractionSuccessFooterTemplate = "<div class=\"Card-footer--simple InfractionsModal-footer\">\n  <%  if (goToUrl != null) {  %>\n    <a href=\"<%=  goToUrl  %>\" class=\"btn btn-primary\"><%- T_('Continua') %></a>\n  <%  } else {  %>\n    <button type=\"button\" class=\"btn\" data-modal-hide><%- T_('Fatto') %></button>\n  <%  }  %>\n</div>\n";

var _templateObject$2 = _taggedTemplateLiteral(['Aiutaci a capire che succede'], ['Aiutaci a capire che succede']),
    _templateObject2 = _taggedTemplateLiteral(['Che succede?'], ['Che succede?']),
    _templateObject3 = _taggedTemplateLiteral(['Sta cercando di ricevere dei pagamenti o comunicare al di fuori del sito'], ['Sta cercando di ricevere dei pagamenti o comunicare al di fuori del sito']),
    _templateObject4 = _taggedTemplateLiteral(['Sta pubblicando informazioni di profilo false o fuorvianti'], ['Sta pubblicando informazioni di profilo false o fuorvianti']),
    _templateObject5 = _taggedTemplateLiteral(['Il suo comportamento \xE8 inappropriato o offensivo'], ['Il suo comportamento \xE8 inappropriato o offensivo']),
    _templateObject6 = _taggedTemplateLiteral(['Si sono verificati dei problemi con i suoi progetti'], ['Si sono verificati dei problemi con i suoi progetti']),
    _templateObject7 = _taggedTemplateLiteral(['Ha presentato del lavoro copiato'], ['Ha presentato del lavoro copiato']),
    _templateObject8 = _taggedTemplateLiteral(['Come lo sta facendo?'], ['Come lo sta facendo?']),
    _templateObject9 = _taggedTemplateLiteral(['Descrivi quando e dove \xE8 successo.'], ['Descrivi quando e dove \xE8 successo.']),
    _templateObject10 = _taggedTemplateLiteral(['Il problema \xE8...'], ['Il problema \xE8...']),
    _templateObject11 = _taggedTemplateLiteral(['Grazie per avercelo comunicato.'], ['Grazie per avercelo comunicato.']),
    _templateObject12 = _taggedTemplateLiteral(['Ottime notizie!'], ['Ottime notizie!']),
    _templateObject13 = _taggedTemplateLiteral(['Abbiamo ricevuto la tua segnalazione che esamineremo al pi\xF9 presto prendendo gli opportuni provvedimenti.'], ['Abbiamo ricevuto la tua segnalazione che esamineremo al pi\xF9 presto prendendo gli opportuni provvedimenti.']),
    _templateObject14 = _taggedTemplateLiteral(['Puoi vedere nella nostra discussione chat del 24 aprile che ha chiesto pi\xF9 volte un pagamento verso il suo indirizzo PayPal piuttosto che su Freelancer.com.'], ['Puoi vedere nella nostra discussione chat del 24 aprile che ha chiesto pi\xF9 volte un pagamento verso il suo indirizzo PayPal piuttosto che su Freelancer.com.']),
    _templateObject15 = _taggedTemplateLiteral(['Descrivi cortesemente cosa ti \xE8 sembrato fuorviante.'], ['Descrivi cortesemente cosa ti \xE8 sembrato fuorviante.']),
    _templateObject16 = _taggedTemplateLiteral(['Ha indicato sul suo profilo di avere buone conoscenze di Phyton ma non \xE8 nemmeno capace di scrivere Hello World in Python!'], ['Ha indicato sul suo profilo di avere buone conoscenze di Phyton ma non \xE8 nemmeno capace di scrivere Hello World in Python!']),
    _templateObject17 = _taggedTemplateLiteral(['Ha fatto uso di un linguaggio inappropriato che pu\xF2 essere reperito nelle nostre discussioni chat pi\xF9 recenti.'], ['Ha fatto uso di un linguaggio inappropriato che pu\xF2 essere reperito nelle nostre discussioni chat pi\xF9 recenti.']),
    _templateObject18 = _taggedTemplateLiteral(['Descrivi il problema per piacere.'], ['Descrivi il problema per piacere.']),
    _templateObject19 = _taggedTemplateLiteral(['Il progetto non era professionale o presentava delle Pietre Miliari con disputa.'], ['Il progetto non era professionale o presentava delle Pietre Miliari con disputa.']),
    _templateObject20 = _taggedTemplateLiteral(['Descrivi il modo in cui ha copiato il lavoro.'], ['Descrivi il modo in cui ha copiato il lavoro.']),
    _templateObject21 = _taggedTemplateLiteral(['La sua proposta in questo link https://www.freelancer.com/contestentry/12345 \xE8 stata chiaramente copiata da quest\'altro lavoro nel link a seguire http://stockimages.com/12345'], ['La sua proposta in questo link https://www.freelancer.com/contestentry/12345 \xE8 stata chiaramente copiata da quest\'altro lavoro nel link a seguire http://stockimages.com/12345']),
    _templateObject22 = _taggedTemplateLiteral(['Descrivi il problema per piacere'], ['Descrivi il problema per piacere']),
    _templateObject23 = _taggedTemplateLiteral(['es. La sua proposta in questo link https://www.freelancer.com/contestentry/12345 \xE8 stata chiaramente copiata da quest\'altro lavoro nel link a seguire: http://stockimages.com/12345'], ['es. La sua proposta in questo link https://www.freelancer.com/contestentry/12345 \xE8 stata chiaramente copiata da quest\'altro lavoro nel link a seguire: http://stockimages.com/12345']),
    _templateObject24 = _taggedTemplateLiteral(['Descrivi il problema per piacere (opzionale)'], ['Descrivi il problema per piacere (opzionale)']),
    _templateObject25 = _taggedTemplateLiteral(['Il miglior modo per affrontare questo tipo di problema \xE8 di aprire una disputa per la Pietra Miliare in questione. Clicca su continua qui in basso per iniziare.'], ['Il miglior modo per affrontare questo tipo di problema \xE8 di aprire una disputa per la Pietra Miliare in questione. Clicca su continua qui in basso per iniziare.']),
    _templateObject26 = _taggedTemplateLiteral(['Daremo un\'occhiata all\'account dell utente e lo segnaleremo per l\'abbonamento Aziendale.'], ['Daremo un\'occhiata all\'account dell utente e lo segnaleremo per l\'abbonamento Aziendale.']);

var InfractionsModal = function () {
  /**
                                        * Modal constructor. Initializes the modal to show the category step.
                                        */
  function InfractionsModal(infractionTypes$$1, sourceId, options) {
    _classCallCheck(this, InfractionsModal);

    this.infraction = {
      category: '',
      violation: '',
      comments: '' };

    this.infractionTypes = infractionTypes$$1;
    this.sourceId = sourceId;
    this.session = getCookie('_tracking_session');
    this.options = options;

    if (this.options.context) {
      this.contextName = this.options.context + '_id';
    } else {
      this.contextName = 'reportee_user_id';
    }

    this.infractionTypesIdLookUp = {
      USER_IS_AN_ORGANIZATION: '7',
      PROJECT_ISSUE_WITH_USER: '10',
      OTHER: '12' };

    this.modalOptions = {
      getCategory: {
        title: translate(_templateObject$2),
        bodyTitle: translate(_templateObject2),
        options: [{
          id: 'contactInfo',
          type: translate(_templateObject3) }, {
          id: 'profile',
          type: translate(_templateObject4) }, {
          id: 'behavior',
          type: translate(_templateObject5) }, {
          id: 'project',
          type: translate(_templateObject6) }, {
          id: 'copyright',
          type: translate(_templateObject7) }, this.infractionTypes[11]],

        optionName: 'infractionCategory',
        error: false },

      getType: {
        title: translate(_templateObject$2),
        bodyTitle: translate(_templateObject8),
        options: [],
        optionName: 'infractionType',
        textAreaPlaceholder: '',
        error: false },

      getComments: {
        title: translate(_templateObject$2),
        bodyTitle: translate(_templateObject9),
        optionName: 'infractionComments',
        options: [],
        textAreaPlaceholder: translate(_templateObject10),
        error: false },

      submitted: {},

      defaultSubmitted: {
        title: translate(_templateObject11),
        goToUrl: null,
        bodyTitle: translate(_templateObject12),
        body: translate(_templateObject13) } };

    this.modalId = 'infraction-modal-id';

    if (this.options.defaultInfractionCategory) {
      this.state = 'getInfractionType';
      this.infraction.category = this.options.defaultInfractionCategory;
      this.changeModalContentBasedOnInfractionCategory();

      this.setCurrentModalTemplate();
      this.initializeModal();

      this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted);
      this.bindGetInfractionTypeModalEvents();
    } else {
      this.state = 'getInfractionCategory';

      this.setCurrentModalTemplate();
      this.initializeModal();

      this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted);
      this.bindGetInfractionCategoryModalEvents();
    }
  }

  /**
     * Instantiates the modal class.
     */

  _createClass(InfractionsModal, [{
    key: 'initializeModal',
    value: function initializeModal() {
      var _this = this;

      this.modal = new Modal(this.modalId, this.modalContent, {
        extraClass: 'InfractionsModal',
        onShow: function onShow() {
          _this.setCurrentModalTemplate();
          _this.switchModalContent();
          if (typeof _this.options.onShowCallback === 'function') {
            _this.options.onShowCallback();
          }
        },
        onHide: function onHide() {
          if (typeof _this.options.onHideCallback === 'function') {
            _this.options.onHideCallback();
          }
        } });
    }

    /**
       * Changes modal conent based on the option chosen in the category step.
       */

  }, {
    key: 'changeModalContentBasedOnInfractionCategory',
    value: function changeModalContentBasedOnInfractionCategory() {
      switch (this.infraction.category) {
        case 'contactInfo':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject9),
            textAreaPlaceholder: translate(_templateObject14) });

          this.modalOptions.getType.options = [this.infractionTypes[0], this.infractionTypes[1], this.infractionTypes[2]];

          break;

        case 'profile':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject15),
            textAreaPlaceholder: translate(_templateObject16) });

          this.modalOptions.getType.options = [this.infractionTypes[3], this.infractionTypes[4], this.infractionTypes[5], this.infractionTypes[6]];

          break;

        case 'behavior':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject9),
            textAreaPlaceholder: translate(_templateObject17) });

          this.modalOptions.getType.options = [this.infractionTypes[7], this.infractionTypes[8]];

          break;

        case 'project':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject18),
            textAreaPlaceholder: translate(_templateObject19) });

          this.modalOptions.getType.options = [this.infractionTypes[9], this.infractionTypes[10]];

          break;

        case 'copyright':
          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject20),
            textAreaPlaceholder: translate(_templateObject21) });

          this.modalOptions.getType.options = [this.infractionTypes[12], this.infractionTypes[13]];

          break;

        case 'contestEntry':
          this.modalOptions.getType = _extends({}, this.modalOptions.getType, {
            bodyTitle: translate(_templateObject2),
            options: [this.infractionTypes[12], this.infractionTypes[13], this.infractionTypes[16], this.infractionTypes[14], this.infractionTypes[15], this.infractionTypes[11]] });

          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject22),
            textAreaPlaceholder: translate(_templateObject23) });

          break;

        case 'contestMessage':
          this.modalOptions.getType = _extends({}, this.modalOptions.getType, {
            bodyTitle: translate(_templateObject2),
            options: [this.infractionTypes[2], this.infractionTypes[8], this.infractionTypes[11]] });

          this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
            bodyTitle: translate(_templateObject24) });

          break;

        default:
          break;}

      if (this.infraction.violation === this.infractionTypesIdLookUp.OTHER) {
        this.modalOptions.getComments = _extends({}, this.modalOptions.getComments, {
          bodyTitle: translate(_templateObject18),
          textAreaPlaceholder: translate(_templateObject10) });
      }
    }

    /**
       * Changes modal conent based on the option chosen in the infraction type.
       */

  }, {
    key: 'changeModalContentBasedOnInfractionType',
    value: function changeModalContentBasedOnInfractionType() {
      if (this.infraction.violation == this.infractionTypesIdLookUp.PROJECT_ISSUE_WITH_USER) {
        this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted, {
          goToUrl: '/dispute/disputeslist.php',
          bodyTitle: '',
          body: translate(_templateObject25) });
      } else if (this.infraction.violation == this.infractionTypesIdLookUp.USER_IS_AN_ORGANIZATION) {
        this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted, {
          bodyTitle: '',
          body: translate(_templateObject26) });
      } else {
        this.modalOptions.submitted = _extends({}, this.modalOptions.defaultSubmitted);
      }
    }

    /**
       * Switches the modal content based on the current state.
       * This creates a new template for the modal, replacing the current one,
       * and binds the event listeners to the new content.
       *
       * @param {Boolean} error Toggle for showing error
       */

  }, {
    key: 'switchModalContent',
    value: function switchModalContent() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.setCurrentModalTemplate(error);
      this.modal.replaceTemplate(this.modalContent);

      switch (this.state) {
        case 'getInfractionCategory':
          this.bindGetInfractionCategoryModalEvents();
          break;
        case 'getInfractionType':
          this.bindGetInfractionTypeModalEvents();
          break;
        case 'getInfractionComments':
          this.bindGetInfractionCommentsModalEvents();
          break;
        default:
          break;}
    }

    /**
       * Sets the modal template to be used based on the current state.
       *
       * @param {Boolean} error Toggle for showing error
       */

  }, {
    key: 'setCurrentModalTemplate',
    value: function setCurrentModalTemplate() {
      var _this2 = this;

      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var currentModalOptions = void 0;

      switch (this.state) {
        case 'getInfractionCategory':
          currentModalOptions = this.modalOptions.getCategory;
          break;
        case 'getInfractionType':
          currentModalOptions = this.modalOptions.getType;
          break;
        case 'getInfractionComments':
          currentModalOptions = this.modalOptions.getComments;
          break;
        case 'infractionSubmitted':
          currentModalOptions = this.modalOptions.submitted;
          break;
        default:
          break;}

      var modalOptions = _extends({
        uiIcon: uiIcon,
        T_: translate,
        defaultInfractionCategory: this.options.defaultInfractionCategory
      }, currentModalOptions, this.infraction);

      if (this.state === 'infractionSubmitted') {
        this.modalContent = {
          header: template(infractionSuccessHeaderTemplate)(modalOptions),
          body: template(infractionSuccessBodyTemplate)(modalOptions),
          footer: template(infractionSuccessFooterTemplate)(modalOptions) };
      } else {
        // disable next button only when there are no options or comments
        var noComments = modalOptions.optionName === 'infractionComments' && modalOptions.comments === '';

        var optionsSelected = modalOptions.options.filter(function (option) {
          return option.id === _this2.infraction.category || option.id === _this2.infraction.violation;
        });

        modalOptions.error = error;
        modalOptions.disableNext = noComments || optionsSelected.length < 1;

        this.modalContent = {
          header: template(infractionFormHeaderTemplate)(modalOptions),
          body: template(infractionFormBodyTemplate)(modalOptions),
          footer: template(infractionFormFooterTemplate)(modalOptions) };
      }
    }

    /**
       * Shows a generic error to the user.
       * This already sets the template and switches the content.
       */

  }, {
    key: 'showError',
    value: function showError() {
      this.state = 'getInfractionComments';
      this.switchModalContent(true);
    }

    /**
       * Submits the infractions form to GAF.
       */

  }, {
    key: 'submitInfraction',
    value: function submitInfraction() {
      var _this3 = this;

      this.trackSubmit();

      // show loading icon
      document.querySelector('.InfractionsModal-next').classList.add('processing');

      var context = this.options.context || 'profile';

      var data = new FormData();
      data.append('url', window.location.href);
      data.append('objid', this.sourceId);
      data.append('objtype', context);
      data.append('reason', 'other');
      data.append('comments', this.infraction.comments);
      data.append('infraction_type_id', parseInt(this.infraction.violation, 10));

      var headers = new Headers({
        'X-XSRF-TOKEN': getCSRFToken() });

      fetch('/ajax/violation/new.php', {
        headers: headers,
        method: 'POST',
        body: data,
        credentials: 'same-origin' }).then(function (response) {
        if (response.ok) {
          _this3.state = 'infractionSubmitted';
          _this3.switchModalContent();
        } else {
          _this3.showError();
        }
      }).catch(function () {
        _this3.showError();
      });
    }

    /**
       * Event listeners for radio buttons.
       */

  }, {
    key: 'bindOptionEvent',
    value: function bindOptionEvent() {
      var nextButton = document.querySelector('.InfractionsModal-next');
      var options = document.querySelectorAll('.InfractionsModal-option');

      Array.prototype.forEach.call(options, function (option) {
        option.addEventListener('click', function () {
          nextButton.disabled = false;
        });
      });
    }

    /**
       * Event listeners for the category step.
       */

  }, {
    key: 'bindGetInfractionCategoryModalEvents',
    value: function bindGetInfractionCategoryModalEvents() {
      var _this4 = this;

      this.bindOptionEvent();

      // setup get infraction type modal based on chosen violation
      var nextButton = document.querySelector('.InfractionsModal-next');
      nextButton.addEventListener('click', function () {
        var selectedOption = document.querySelector('.InfractionsModal-options > input[type="radio"]:checked').value;

        var choseOtherViolation = selectedOption == _this4.infractionTypesIdLookUp.OTHER;

        if (choseOtherViolation) {
          _this4.infraction.violation = selectedOption;
        } else {
          _this4.infraction.violation = 0;
          _this4.infraction.category = selectedOption;
        }

        _this4.trackModalNextStep();
        _this4.changeModalContentBasedOnInfractionCategory();
        _this4.modalOptions.getComments.error = false;

        _this4.state = choseOtherViolation ? 'getInfractionComments' : 'getInfractionType';
        _this4.switchModalContent();
      });
    }

    /**
       * Event listeners for infraction type step.
       */

  }, {
    key: 'bindGetInfractionTypeModalEvents',
    value: function bindGetInfractionTypeModalEvents() {
      var _this5 = this;

      this.bindOptionEvent();

      // set submission modal content
      var nextButton = document.querySelector('.InfractionsModal-next');
      nextButton.addEventListener('click', function () {
        _this5.infraction.violation = document.querySelector('.InfractionsModal-options > input[type="radio"]:checked').value;
        _this5.changeModalContentBasedOnInfractionType();

        _this5.trackModalNextStep();
        _this5.modalOptions.getComments.error = false;

        // if there was an issue with a project, send them to disputes page
        // otherwise, go to comments modal
        _this5.state = _this5.infraction.violation == _this5.infractionTypesIdLookUp.PROJECT_ISSUE_WITH_USER ? 'infractionSubmitted' : 'getInfractionComments';

        _this5.switchModalContent();
      });

      if (!this.options.defaultInfractionCategory) {
        // go back to infraction modal
        var backButton = document.querySelector('.InfractionsModal-back');
        backButton.addEventListener('click', function () {
          _this5.state = 'getInfractionCategory';
          _this5.switchModalContent();
        });
      }
    }

    /**
       * Event listeners for infraction comments step.
       */

  }, {
    key: 'bindGetInfractionCommentsModalEvents',
    value: function bindGetInfractionCommentsModalEvents() {
      var _this6 = this;

      // enable next button if comments exists
      var nextButton = document.querySelector('.InfractionsModal-next');
      var commentsNode = document.querySelector('.InfractionsModal-comments');

      if (this.options.isCommentOptional) {
        nextButton.disabled = false;
      } else {
        commentsNode.addEventListener('input', function () {
          var hasComments = commentsNode.value === '';
          nextButton.disabled = hasComments;
        });
      }

      nextButton.addEventListener('click', function () {
        _this6.infraction.comments = commentsNode.value;

        if (!_this6.options.isCommentOptional && _this6.infraction.comments.trim().length === 0) {
          _this6.showError();
          return false;
        }

        _this6.submitInfraction();
      });

      // go back to previous modal
      var backButton = document.querySelector('.InfractionsModal-back');
      backButton.addEventListener('click', function () {
        _this6.state = _this6.infraction.violation == _this6.infractionTypesIdLookUp.OTHER && !_this6.options.defaultInfractionCategory ? 'getInfractionCategory' : 'getInfractionType';

        _this6.switchModalContent();
      });
    }

    /**
       * Tracks when the modal was opened.
       */

  }, {
    key: 'trackModalOpen',
    value: function trackModalOpen() {
      window._t.push(['user_action', {
        section: 'InfractionModal',
        label: 'ShowModal',
        reference: this.contextName,
        reference_id: this.sourceId,
        session_id: this.session.id,
        user_id: getUserIdfromCookie() }]);
    }

    /**
       * Tracks when we move to the next step.
       */

  }, {
    key: 'trackModalNextStep',
    value: function trackModalNextStep() {
      window._t.push(['user_action', {
        section: 'InfractionModal',
        subsection: this.state,
        label: 'Continue',
        reference: this.contextName,
        reference_id: this.sourceId,
        session_id: this.session.id,
        user_id: getUserIdfromCookie(),
        name: 'infraction_type_id',
        value: this.infraction.violation }]);
    }

    /**
       * Tracks when we submit the form.
       */

  }, {
    key: 'trackSubmit',
    value: function trackSubmit() {
      window._t.push(['user_action', {
        section: 'InfractionModal',
        subsection: this.state,
        label: 'Submit',
        reference: this.contextName,
        reference_id: this.sourceId,
        session_id: this.session.id,
        user_id: getUserIdfromCookie(),
        name: 'input',
        value: this.infraction.comments }]);
    }
  }]);

  return InfractionsModal;
}();

var errorModalTemplate = "<div id=\"contest-error-modal\" class=\"modal above-quickview hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3><%- T_(\"Errore\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-error\">\n      <p><%=  message  %></p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Chiudi\") %></button>\n  </div>\n</div>\n";

var successModalTemplate = "<div id=\"contest-success-modal\" class=\"modal above-quickview hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3><%- T_(\"Operazione riuscita\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-success\">\n      <p><%=  message  %></p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Chiudi\") %></button>\n  </div>\n</div>\n";

var infoModalTemplate = "<div id=\"contest-info-modal\" class=\"modal hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3>\n      <%-  title  %>\n    </h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-info\">\n      <div id=\"messageContainer\"><%=  message  %></div>\n      <div id=\"modalLoader\" class=\"Loader Loader--small Loader--full is-hidden\"></div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Chiudi\") %></button>\n  </div>\n</div>\n";

var limitReachedModalTemplate = "<div id=\"contest-error-modal\" class=\"modal above-quickview hide\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3><%- T_(\"Hai raggiunto il numero massimo di proposte per questo concorso\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"alert alert-error\">\n      <p>\n        <%= T_(\"<a href='/membership'>Potenzia il tuo account</a> con un abbonamento per sbloccare proposte illimitate per i concorsi.\") %>\n      </p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Chiudi\") %></button>\n  </div>\n</div>\n";

var defaultOptions$1 = {
  container: document.getElementById('contest_popup-container'),
  message: '',
  template: ''
};

var compiledErrorModalTemplate = template(errorModalTemplate);
var compiledSuccessModalTemplate = template(successModalTemplate);
var compiledInfoModalTemplate = template(infoModalTemplate);
var compiledLimitReachedModalTemplate = template(limitReachedModalTemplate);

var AlertModal = function () {
  function AlertModal(options) {
    var _this = this;

    _classCallCheck(this, AlertModal);

    this.options = Object.assign({}, defaultOptions$1, options);

    this.modal = jq(this.options.template({
      T_: translate,
      message: this.options.message,
      title: this.options.title
    }));

    this.options.container.appendChild(this.modal.get(0));

    this.modal.on('hidden.bs.modal', function () {
      _this.modal.remove();
      _this.options.onHideCallback();
    });
  }

  _createClass(AlertModal, [{
    key: 'show',
    value: function show() {
      this.modal.modal('show');
      return this;
    }

    /**
     * Returns the bootstrap modal
     * @returns {AlertModal.modal|*}
     */

  }, {
    key: 'getModal',
    value: function getModal() {
      return this.modal;
    }
  }]);

  return AlertModal;
}();

function createModal(message, compiledTemplate, container, onHideCallback, title) {
  var params = {
    message: message,
    template: compiledTemplate,
    title: title
  };

  if (container) {
    params.container = container;
  }

  params.onHideCallback = jq.noop;
  if (onHideCallback) {
    params.onHideCallback = onHideCallback;
  }

  return new AlertModal(params);
}

function showErrorModal(message, container) {
  return createModal(message, compiledErrorModalTemplate, container).show();
}

var contestMessageModalTemplate = "<div id=\"contest-message-delete\" class=\"modal hide contest-message-popup above-quickview in\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n    <h3><%- T_(\"Elimina messaggio\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      <strong>\n        <%- T_(\"Sei sicuro di voler eliminare questo messaggio?\") %>\n      </strong>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"modal-loading hide\" >\n      <img src=\"<%=  cdn_url('/img/dashboard-pending.gif')  %>\">\n    </div>\n    <div class=\"error-msg\"></div>\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Annulla\") %></button>\n    <button class=\"btn btn-info confirm-message-delete\"\n      data-selector=\"delete\"\n      data-target=\"confirm-delete\"\n      data-msg-id=\"<%-  msgId  %>\"\n      data-hash=\"<%-  hash  %>\"\n    >\n    <%- T_(\"Cancella\") %>\n  </button>\n</div>\n</div>\n\n<div id=\"contest-message-delete-thread\" class=\"modal hide contest-message-popup above-quickview in\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n    <h3><%- T_(\"Cancella discussione\") %></h3>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      <strong>\n        <%- T_(\"Sei sicuro di voler eliminare questo messaggio e tutte le risposte relative a esso?\") %>\n      </strong>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"modal-loading hide\" >\n      <img src=\"<%=  cdn_url('/img/dashboard-pending.gif')  %>\">\n    </div>\n    <div class=\"error-msg\"></div>\n    <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Annulla\") %></button>\n    <button class=\"btn btn-info confirm-message-thread-delete\"\n      data-selector=\"delete\"\n      data-target=\"confirm-delete\"\n      data-msg-id=\"<%-  msgId  %>\"\n      data-hash=\"<%-  hash  %>\"\n    >\n    <%- T_(\"Cancella\") %>\n  </button>\n</div>\n</div>\n";

var TYPE$1 = {
  MESSAGE_DELETE_MODAL: 'delete-thread',
  REPLY_DELETE_MODAL: 'delete-reply'
};

var compiledMessageModalTemplate = template(contestMessageModalTemplate);

var ContestMessageModal = function () {
  function ContestMessageModal(options) {
    _classCallCheck(this, ContestMessageModal);

    this.modal = null;

    this.options = {
      container: null,
      onDeleteMessage: function onDeleteMessage() {}
    };

    this.options = Object.assign({}, this.options, options);

    this.selectors = {
      modalDeleteThread: '#contest-message-delete-thread',
      modalDeleteReply: '#contest-message-delete',
      btnDelete: '[data-selector="delete"]',
      violationReason: '#message-violation-reason'
    };

    this.modalMap = {};
    this.modalMap[TYPE$1.MESSAGE_DELETE_MODAL] = this.selectors.modalDeleteThread;
    this.modalMap[TYPE$1.REPLY_DELETE_MODAL] = this.selectors.modalDeleteReply;
  }

  _createClass(ContestMessageModal, [{
    key: 'show',
    value: function show(messageId, hash, type) {
      this.modal = jq(compiledMessageModalTemplate({
        msgId: messageId,
        hash: hash,
        T_: translate,
        cdn_url: cdn_url
      }));

      this.options.container.html(this.modal);
      bindButtonEvents(this);
      jq(this.modalMap[type]).modal('show');
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.modal.modal('hide');
      this.modal.remove();
    }
  }]);

  return ContestMessageModal;
}();

function bindButtonEvents(modal) {
  modal.options.container.find(modal.selectors.btnDelete).click(modal.options.onDeleteMessage);

  modal.modal.on('hidden.bs.modal', function () {
    return modal.modal.remove();
  });
}

var pcbTriggerTemplate = "<%= T_('Richiedi ai titolari dei concorsi di incrementare il premio e di aggiornare il concorso pubblicando <[= tags ]>.', { 'tags': tags }) %>\n";

var hashtagTriggerTemplate = "<a href=\"#\" class=\"pcb-hashtag-trigger\" data-selector=\"pcb-hashtag-trigger\" data-tag=\"<%-  tagName  %>\">#<%-  tagName  %></a>\n";

var hashtagTemplate = "<a href=\"#\" class=\"pcb-hashtag\" data-selector=\"pcb-hashtag\" data-tag=\"<%-  tag  %>\" data-tag-type=\"<%-  type  %>\"\n  <%  if (value !== null) {  %>\n    data-value=\"<%-  value  %>\"\n  <%  }  %>>\n  #<%-  tag  %>\n</a>\n";

var compiledPcbTriggerTemplate = template(pcbTriggerTemplate);
var compiledHashtagTriggerTemplate = template(hashtagTriggerTemplate);
var compiledHashtagTemplate = template(hashtagTemplate);

var MessageHashtags = function () {
  function MessageHashtags() {
    _classCallCheck(this, MessageHashtags);

    this.enabled = true;
    this.callbacks = {};
    this.container = document.createElement('div');
    this.hashtags = {
      extended: {
        type: 'upgrade',
        value: 'extend',
        label: 'Extended'
      },
      guaranteed: {
        type: 'upgrade',
        value: 'guaranteed',
        label: 'Guaranteed'
      },
      sealed: {
        type: 'upgrade',
        value: 'sealed',
        label: 'Sealed'
      },
      increaseprize: {
        type: 'prize',
        label: 'IncreasePrize'
      }
    };
    this.disabledTags = {}; // set of tags removed from triggers or disabled
    this.options = {
      triggersEnabled: true, // put hashtag triggers
      tagsEnabled: true, // parse hashtags in message but no functionality
      hashtagCountLimit: 1, // max number of hashtags per type in a msg
      selectors: {
        hashtag: '[data-selector="pcb-hashtag"]',
        trigger: '[data-selector="pcb-hashtag-trigger"]'
      }
    };
  }

  _createClass(MessageHashtags, [{
    key: 'init',
    value: function init(options) {
      var _this = this;

      var selectors = Object.assign({}, this.options.selectors, options.selectors);

      this.options = Object.assign({}, this.options, options);
      this.options.selectors = selectors;

      if (typeof options.enabled !== 'undefined') {
        this.enabled = !!options.enabled;
      }

      if (!this.enabled) {
        return;
      }

      if (options.disabledTags) {
        var disabledTagsKeys = Object.keys(options.disabledTags);
        if (disabledTagsKeys.length) {
          disabledTagsKeys.forEach(function (tag) {
            _this.disableTag(tag);
          });
        }
      }
    }
  }, {
    key: 'transformTags',
    value: function transformTags(message, transformCallback) {
      var _this2 = this;

      if (!this.enabled) {
        return message;
      }

      var regex = /#([a-z]+)/g;
      var hashtagCounts = {};

      return message.replace(regex, function (match, hash) {
        if (hash in _this2.hashtags) {
          if (!_this2.options.tagsEnabled || hash in _this2.disabledTags) {
            var tag = document.createElement('strong');
            tag.innerHTML = match;
            return tag.outerHTML;
          }

          if (!hashtagCounts[hash]) {
            hashtagCounts[hash] = 0;
          }

          if (hashtagCounts[hash] < _this2.options.hashtagCountLimit) {
            var tagValue = _this2.hashtags[hash];
            hashtagCounts[hash]++;
            if (transformCallback) {
              transformCallback(tagValue);
            }

            return compiledHashtagTemplate({
              type: tagValue.type,
              tag: hash,
              value: tagValue.value
            });
          }
        }

        return match;
      });
    }
  }, {
    key: 'addTriggers',
    value: function addTriggers(container) {
      var _this3 = this;

      if (!this.enabled || !this.options.triggersEnabled) {
        return;
      }

      var hashtagLinks = Object.keys(this.hashtags).filter(function (tagName) {
        return !(tagName in _this3.disabledTags);
      }).map(function (tagName) {
        return compiledHashtagTriggerTemplate({ tagName: tagName }).trim();
      });

      if (hashtagLinks.length) {
        container.html(compiledPcbTriggerTemplate({
          tags: hashtagLinks.join(', '),
          T_: translate
        }));

        this.attachTriggerEventHandlers(container);
      }
    }
  }, {
    key: 'attachTagEventHandlers',
    value: function attachTagEventHandlers(container) {
      var _this4 = this;

      container.on('click', this.options.selectors.hashtag, function (event) {
        event.preventDefault();
        var hashtag = event.target;
        var tag = hashtag.getAttribute('data-tag');
        var tagData = _this4.getTag(tag);
        if (tagData) {
          tagData.el = hashtag;
          _this4.trigger('hashtagClicked', tagData);
        }
      });
    }
  }, {
    key: 'attachTriggerEventHandlers',
    value: function attachTriggerEventHandlers(container) {
      var _this5 = this;

      container.off().on('click', this.options.selectors.trigger, function (event) {
        event.preventDefault();
        var trigger = event.target;
        var tag = trigger.getAttribute('data-tag');
        var tagData = _this5.getTag(tag);
        if (tagData) {
          tagData.el = trigger;
          _this5.trigger('triggerClicked', tagData);
        }
      });
    }
  }, {
    key: 'getTag',
    value: function getTag(tag) {
      if (tag in this.hashtags) {
        var tagValue = this.hashtags[tag];
        return {
          tag: tag,
          type: tagValue.type,
          value: tagValue.value
        };
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event, data) {
      if (this.callbacks[event] && this.callbacks[event].length) {
        this.callbacks[event].forEach(function (callbackEventFunc) {
          callbackEventFunc(data);
        });
      }
    }
  }, {
    key: 'disableTag',
    value: function disableTag(tag) {
      if (tag in this.hashtags) {
        this.disabledTags[tag] = true;
      }
    }
  }, {
    key: 'on',
    value: function on(event, callback) {
      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }
      this.callbacks[event].push(callback);
    }
  }]);

  return MessageHashtags;
}();

var contestMessageTemplate = "<li class=\"commentBoard-comment\" data-selector=\"comment-main\">\n  <img src=\"<%-  profile_logo_url  %>\" class=\"commentBoard-avatar\" alt=\"<%- T_('Immagine di profilo') %>\" />\n  <header class=\"commentBoard-headerItems\">\n    <%  if (is_holder_message) {  %>\n      <span class=\"commentBoard-userType\"><%- T_('Titolare del concorso') %></span>\n    <%  } else if (isUserMessage){  %>\n      <h6 class=\"commentBoard-commentHeader\">\n        <%-  publicUserName  %>\n      </h6>\n    <%  } else {  %>\n      <h6 class=\"commentBoard-commentHeader\">\n        <a href=\"/u/<%-  username  %>\" data-selector=\"comment-username\"><%-  publicUserName  %></a>\n      </h6>\n    <%  }  %>\n    <ul class=\"commentBoard-commentDetails\" data-selector=\"comment-details\"></ul>\n  </header>\n  <p data-selector=\"comment-formatted-message\"><%=  formattedComment  %></p>\n  <%  if (!parentId) {  %>\n    <%  if (numHidden > 0) {  %>\n      <div class=\"view-more-comment\">\n        <a href=\"javascript:void(0)\" class=\"small\" data-selector=\"view-more-comment-link\">\n          <%  if(numHidden !== 1){ %>\n            <%- T_('Visualizza altri <[- numHidden ]> messaggi', { numHidden: numHidden }) %>\n          <%  } else {  %>\n            <%- T_('Visualizza 1 altro messaggio') %>\n          <%  }  %>\n        </a>\n        <img src=\"<%-  cdn_url('/img/ajax-loader.gif')  %>\"\n          class=\"view-more-comment-loader hide\"\n          data-selector=\"view-more-comment-loader\"\n          alt=\"<%- T_('In elaborazione...') %>\"/>\n      </div>\n    <%  }  %>\n    <ol class=\"commentBoard-subList contest-replies\" data-selector=\"comment-reply-list\"></ol>\n  <%  }  %>\n  <ul class=\"commentBoard-commentDetails commentBoard-mobile\" data-selector=\"comment-details\"></ul>\n  <%  if (!parentId) {  %>\n    <div class=\"Comment Comment--commentBoard is-hidden\" data-selector=\"comment-reply\">\n      <figure class=\"Comment-profile\">\n        <img src=\"<%-  profilePic  %>\" width=\"56\" height=\"56\"\n          alt=\"<%- T_('Immagine di profilo') %>\" class=\"Comment-profileImage\" />\n      </figure>\n      <form class=\"Comment-form\" data-selector=\"comment-form\" data-load=\"loading/loading-overlay\">\n        <textarea placeholder=\"<%- T_('Scrivi un commento...') %>\"\n          class=\"Comment-field\" data-selector=\"comment-reply-input\"\n          rows=\"1\" ></textarea>\n        <div class=\"loading-overlay is-loading pcb-loader is-hidden\" data-selector=\"loading-overlay\"></div>\n        <div class=\"pcb_error alert alert-error hide\" data-selector=\"comment-error\"></div>\n        <div class=\"pcb-hashtag-container\" data-selector=\"pcb-hashtag-container\"></div>\n      </form>\n    </div>\n  <%  }  %>\n</li>\n";

var contestMessageControlsTemplate = "<li data-selector=\"comment-timestamp\"><%-  formattedDate  %></li>\n<%  if (canBeRepliedTo) {  %>\n  <li>\n    <a class=\"commentBoard-reply\" data-selector=\"comment-control-reply\">\n      <%- T_('Rispondi') %>\n    </a>\n  </li>\n<%  }  %>\n<%  if (canBeDeleted) {  %>\n  <li>\n    <a class=\"commentBoard-delete\" data-selector=\"comment-control-delete\">\n      <%- T_('Cancella') %>\n    </a>\n  </li>\n<%  }  %>\n<%  if (canBeReported) {  %>\n  <li>\n    <a class=\"commentBoard-report\" data-selector=\"comment-control-report\">\n      <%- T_('Segnala') %>\n    </a>\n  </li>\n<%  }  %>\n";

var emptyMessageTemplate = "<p id=\"no_msgs\" class=\"no-message\" data-selector=\"empty-message\"><%- T_('Nessun messaggio.') %></p>\n";

var THREAD_DISPLAY_SIZE = 2;
var KEYCODE_ENTER = 13;
var hideClass = 'is-hidden';
var messageApi = new MessageApi();
var messageHashtags = new MessageHashtags();
var compiledEmptyMessageTemplate = template(emptyMessageTemplate);
var lt = new LocalTracking();

var Message = function () {
  function Message(messageData, messageBoard, isReply, template$$1) {
    var _this = this;

    _classCallCheck(this, Message);

    this.parent = messageBoard;
    this.data = {
      annotationId: null,
      entryId: null,
      fileId: null,
      formattedComment: null,
      formattedDate: null,
      is_holder_message: false,
      is_private_message: false,
      msg_id: null,
      parentId: null,
      privacy: null,
      profile_logo_url: null,
      threadMsgs: [],
      threadSize: 0,
      timestamp: null,
      toUserId: null,
      totalHiddenMessages: 0,
      userId: null,
      user_url: null,
      username: null,
      xCoordinate: null,
      yCoordinate: null };

    this.data = Object.assign({}, this.data, messageData);
    this.isReply = isReply;
    this.reportMessageModal = null;
    this.replies = [];
    this.template = template$$1 || this.getMessageTemplate();
    this.modalContainer = jq('#contest_popup-container');
    this.contestMessageModal = new ContestMessageModal({
      container: this.modalContainer,
      onDeleteMessage: function onDeleteMessage() {
        return _this.onDeleteConfirm();
      } });

    this.bindMessageEvents();
  }

  _createClass(Message, [{
    key: 'getMessageTemplate',
    value: function getMessageTemplate() {
      var options = this.parent.options;
      var rawTemplate = options.messageTemplate || contestMessageTemplate;

      if (!this.isReply) {
        this.data.numHidden = this.data.threadSize - THREAD_DISPLAY_SIZE;
      } else {
        this.data.numHidden = 0;
      }

      this.data.profilePic = options.user.profilePic;
      this.data.isUserMessage = options.user.id === parseInt(this.data.userId, 10);

      if (this.isContestHolderMessage()) {
        this.data.formattedComment = messageHashtags.transformTags(this.data.formattedComment);
      }

      var controlVars = {
        canBeDeleted: options.controls.delete && (options.contest.isContestHolder || this.data.isUserMessage),
        canBeReported: options.controls.report && !this.data.isUserMessage,
        canBeRepliedTo: options.controls.reply && !this.data.parentId,
        formattedDate: this.data.formattedDate,
        T_: translate };

      this.data.T_ = translate;
      this.data.cdn_url = cdn_url;

      var messageTemplate = jq(template(rawTemplate)(this.data));
      var messageControlsTemplate = jq(template(contestMessageControlsTemplate)(controlVars));

      messageTemplate.find(options.selectors.commentDetails).append(messageControlsTemplate);

      return messageTemplate;
    }
  }, {
    key: 'isContestHolderMessage',
    value: function isContestHolderMessage() {
      return !this.data.is_holder_message;
    }
  }, {
    key: 'bindMessageEvents',
    value: function bindMessageEvents() {
      var _this2 = this;

      this.template.find(this.parent.options.selectors.viewMoreCommentLink).click(function (event) {
        return _this2.onViewMoreRepliesClick(event);
      });
      this.template.find(this.parent.options.selectors.commentControlReply).click(function (event) {
        return _this2.onReplyClick(event);
      });
      this.template.find(this.parent.options.selectors.commentControlDelete).click(function (event) {
        return _this2.onDeleteClick(event);
      });
      this.template.find(this.parent.options.selectors.commentControlReport).click(function () {
        return _this2.onReportClick();
      });
      this.template.find(this.parent.options.selectors.textArea).keydown(function (event) {
        return onInputFieldKeydown(_this2, event, true);
      });

      if (this.data.annotationId) {
        this.template.click(function (event) {
          return _this2.onCommentClick(event);
        });
      }

      this.template.find(this.parent.options.selectors.username).click(function () {
        return _this2.onUsernameClick();
      });

      messageHashtags.addTriggers(this.template.find(this.parent.options.selectors.pcbHashtagContainer));

      messageHashtags.attachTagEventHandlers(this.template);
    }
  }, {
    key: 'onUsernameClick',
    value: function onUsernameClick() {
      var subsection = '';

      if (this.data.entryId) {
        subsection = 'EntryQuickViewClarificationBoard';
      } else {
        subsection = 'ContestClarificationBoard';
      }

      lt.push(['user_action', {
        section: 'ContestViewPage',
        subsection: subsection,
        name: 'clickUsername',
        reference: 'contest_id',
        reference_id: this.parent.options.contest.id,
        label: 'user_id',
        value: this.data.userId }]);
    }
  }, {
    key: 'onViewMoreRepliesClick',
    value: function onViewMoreRepliesClick(event) {
      var _this3 = this;

      var currentTarget = jq(event.currentTarget);
      currentTarget.parent().find(this.parent.options.selectors.viewMoreCommentLoader).show();
      currentTarget.hide();

      getMessages(this.parent, {
        parent_id: this.data.msg_id,
        project_id: this.parent.options.contest.id }).then(function (messageData) {
        if (messageData && messageData.messages) {
          (function () {
            var fragment = jq(document.createDocumentFragment());
            messageData.messages.filter(function (threadMsg) {
              return !_this3.replies[threadMsg.msg_id];
            }).forEach(function (threadMsg) {
              var reply = new Message(threadMsg, _this3.parent, true);
              _this3.addReply(fragment, reply, true);
            });

            currentTarget.closest(_this3.parent.options.selectors.comment).find(_this3.parent.options.selectors.replies).prepend(fragment);
            currentTarget.parent().hide();
          })();
        }
      }).catch(function (error) {
        return _this3.parent.options.events.onError(error);
      });
    }
  }, {
    key: 'onReplyClick',
    value: function onReplyClick(event) {
      var replyContainer = jq(event.target).closest(this.parent.options.selectors.comment);

      var replySection = replyContainer.find(this.parent.options.selectors.reply);

      if (replySection.hasClass(hideClass)) {
        replySection.fadeIn('fast');
        replySection.removeClass(hideClass);
        replyContainer.find(this.parent.options.selectors.textArea).focus();
      } else {
        replySection.fadeOut('fast');
        replySection.addClass(hideClass);
      }
    }
  }, {
    key: 'onDeleteClick',
    value: function onDeleteClick(event) {
      var comment = jq(event.target).closest(this.parent.options.selectors.comment);

      var msgId = this.data.msg_id;
      var hash = '';
      var modalType = TYPE$1.REPLY_DELETE_MODAL;

      if (comment.find(this.parent.options.selectors.replies).children().length > 0) {
        modalType = TYPE$1.MESSAGE_DELETE_MODAL;
      }

      this.contestMessageModal.show(msgId, hash, modalType);
    }
  }, {
    key: 'onDeleteConfirm',
    value: function onDeleteConfirm() {
      this.deleteMessage().catch(function () {});
      this.contestMessageModal.hide();
    }
  }, {
    key: 'onReportClick',
    value: function onReportClick() {
      lt.push(['user_action', {
        section: this.parent.options.pageName,
        subsection: 'PublicClarificationBoard',
        name: 'ReportViolation',
        reference: 'contest_message_id',
        reference_id: this.data.msg_id,
        label: 'contest_id',
        value: this.parent.options.contest.id }]);

      if (!this.reportMessageModal) {
        this.reportMessageModal = new InfractionsModal(this.parent.options.infractionTypes, this.data.msg_id, {
          defaultInfractionCategory: 'contestMessage',
          isCommentOptional: true,
          context: 'contest_message' });
      }
      this.reportMessageModal.modal.show();
    }
  }, {
    key: 'onCommentClick',
    value: function onCommentClick(event) {
      if (!this.parent.options.enableAnnotations) {
        return false;
      }

      var eventTarget = jq(event.target);
      if (eventTarget.is('a') || eventTarget.is('textarea')) {
        return false;
      }

      this.parent.options.events.onMessageClicked(event, this);
    }
  }, {
    key: 'moderateMessage',
    value: function moderateMessage(options) {
      var data = {
        project_id: this.parent.options.contest.id,
        msg_id: options.messageId };

      return messageApi.deleteMessage(data);
    }
  }, {
    key: 'addReply',
    value: function addReply(container, reply, prepend) {
      this.replies[reply.data.msg_id] = reply;
      if (prepend) {
        container.prepend(reply.template);
      } else {
        container.append(reply.template);
      }
    }
  }, {
    key: 'updateMessage',
    value: function updateMessage(newMessageText) {
      var _this4 = this;

      var currentMessageText = this.data.formattedComment;
      var inputField = this.template.find(this.parent.options.selectors.textArea).first();
      var errorMessage = void 0;

      inputField.prop('disabled', true);
      inputField.parent().find('.loading-overlay').removeClass(hideClass);
      jq(this.parent.options.selectors.pcbError).hide();

      return new Promise(function (resolve, reject) {
        messageApi.updateMessage({
          message_id: parseInt(_this4.data.msg_id, 10),
          message: newMessageText }).then(function (response) {
          if (response.status !== 'failed') {
            inputField.val('');

            _this4.data.formattedComment = response.message.formattedComment;
            _this4.data.formattedDate = response.message.formattedDate;
            _this4.data.timestamp = response.message.timestamp;

            var firstComment = _this4.parent.options.messageContainer.children().first();
            // The quickview PCB supposedly has two layouts - one for mobile
            // and one for desktop. Each layout has a separate container for
            // the comment details - including the timestamp.
            // We'll update both here.
            var timestampContainers = _this4.template.find(_this4.parent.options.selectors.messageTimestamp);

            var messageTextContainer = _this4.template.find(_this4.parent.options.selectors.formattedMessage).first();

            timestampContainers.html(response.message.formattedDate);
            messageTextContainer.html(response.message.formattedComment);

            if (!_this4.template.is(firstComment)) {
              _this4.template.insertBefore(firstComment).fadeIn('fast');
            }

            onMessageUpdated(_this4.parent, response.message.id, response.message);

            _this4.parent.options.events.onMessageUpdated(response.message.id, response.message);

            resolve(response.message);
          } else {
            if (response.error) {
              errorMessage = response.error;
            }

            if (errorMessage === '') {
              errorMessage = translate('Impossibile inviare il tuo messaggio.');
            }

            _this4.parent.options.events.onError(errorMessage);
            reject(errorMessage, currentMessageText);
          }
        }).catch(function () {
          errorMessage = translate('Errore del server. Impossibile inviare il tuo messaggio.');
          _this4.parent.options.events.onError(errorMessage);
          reject(errorMessage, currentMessageText);
        }).then(function () {
          inputField.prop('disabled', false);
          inputField.parent().find('.loading-overlay').addClass(hideClass);
        });
      });
    }
  }, {
    key: 'deleteMessage',
    value: function deleteMessage() {
      var _this5 = this;

      var errorMessage = translate('Impossibile eliminare il messaggio.');
      var inputField = this.template.find(this.parent.options.selectors.textArea).first();

      inputField.prop('disabled', true);
      inputField.parent().find(this.parent.options.selectors.loadingOverlay).removeClass(hideClass);
      jq(this.parent.options.selectors.pcbError).hide();

      var messageId = this.data.msg_id;

      return new Promise(function (resolve, reject) {
        _this5.moderateMessage({
          messageId: messageId,
          action: 'delete' }).then(function (response) {
          if (response && response.success) {
            _this5.template.remove();
            onMessageDeleted(_this5.parent, messageId);
            _this5.parent.options.events.onMessageDeleted(messageId);
            return resolve();
          }

          if (response && response.errors) {
            errorMessage = response.errors.reduce(function (initial, value) {
              return initial + '\n' + value + '. ';
            }, errorMessage);
          }

          throw errorMessage;
        }).catch(function (errorMessage) {
          _this5.parent.options.events.onError(errorMessage);
          reject(errorMessage);
        }).then(function () {
          inputField.prop('disabled', false);
          inputField.parent().find('.loading-overlay').addClass(hideClass);
        });
      });
    }
  }]);

  return Message;
}();

var MessageBoard = function () {
  function MessageBoard(options, privacy) {
    var _this6 = this;

    _classCallCheck(this, MessageBoard);

    this.messages = [];
    this.options = {
      contest: {
        id: null,
        contestHolderId: null,
        isContestHolder: false,
        upgrades: null },

      entry: {
        id: 0 },

      user: {
        id: null,
        hasEntries: false,
        profilePic: '' },

      toUser: {
        id: null },

      limit: 50,
      events: {
        onHashtagClick: function onHashtagClick() {},
        onMessagesLoaded: function onMessagesLoaded() {},
        onMessagePostingStart: function onMessagePostingStart() {},
        onMessagePostingEnd: function onMessagePostingEnd() {},
        onMessagePosted: function onMessagePosted() {},
        onMessageUpdated: function onMessageUpdated() {},
        onMessageDeleted: function onMessageDeleted() {},
        onMessageClicked: function onMessageClicked() {},
        onError: showErrorModal },

      preload: {
        enabled: false,
        messagesData: {},
        prerendered: true },

      controls: {
        delete: true,
        reply: true,
        report: true },

      messageHashtags: {
        enabled: false,
        triggersEnabled: false },

      infractionTypes: [],
      enableAnnotations: false,
      messageTemplate: null,
      messageContainer: jq('#MessagesContainer'),
      messageBoardContainer: jq('#MessageBoard'),
      selectors: {
        showMore: '#messages_show_more',
        reply: '[data-selector="comment-reply"]',
        comment: '[data-selector="comment-main"]',
        commentControlReply: '[data-selector="comment-control-reply"]',
        commentControlDelete: '[data-selector="comment-control-delete"]',
        commentControlReport: '[data-selector="comment-control-report"]',
        commentDetails: '[data-selector="comment-details"]',
        commentForm: '[data-selector="comment-form"]',
        textArea: '[data-selector="comment-reply-input"]',
        mainTextArea: '[data-selector="comment-main-input"]',
        viewMoreCommentLink: '[data-selector="view-more-comment-link"]',
        viewMoreCommentLoader: '[data-selector="view-more-comment-loader"]',
        pcbError: '[data-selector="comment-error"]',
        pcbHashtagContainer: '[data-selector="pcb-hashtag-container"]',
        pcbShowComments: '[data-selector="pcb-show-comments"]',
        replies: '[data-selector="comment-reply-list"]',
        loadingOverlay: '[data-selector="loading-overlay"]',
        messageTimestamp: '[data-selector="comment-timestamp"]',
        formattedMessage: '[data-selector="comment-formatted-message"]',
        emptyMessage: '[data-selector="empty-message"]',
        username: '[data-selector="comment-username"]' },

      showEmptyMessage: false,
      pageName: null };

    this.messageStart = 0;
    this.privacy = privacy;

    this.showMoreMessagesContainer = jq(this.options.selectors.showMore);

    var optionsEvents = Object.assign({}, this.options.events, options.events);

    var optionsSelectors = Object.assign({}, this.options.selectors, options.selectors);

    this.options = Object.assign({}, this.options, options);
    this.options.events = optionsEvents;
    this.options.selectors = optionsSelectors;

    this.initializeHashTags();
    this.populateMessageBoard(false, true).then(function () {
      return _this6.bindMessageBoardEvents();
    }).catch(function (error) {
      return _this6.options.events.onError(error);
    });
  }

  _createClass(MessageBoard, [{
    key: 'populateMessageBoard',
    value: function populateMessageBoard(loader, useCache) {
      var _this7 = this;

      var data = {
        start: this.messageStart,
        limit: this.options.limit };

      return getMessages(this, data, useCache).then(function (response) {
        _this7.loadMessages(response.messages);
        _this7.renderMessages();
        _this7.options.events.onMessagesLoaded(response);
        return response;
      }).then(function (response) {
        _this7.options.messageBoardContainer.removeClass(hideClass);
        _this7.showMoreMessagesContainer.find('a').show();

        if (response.total_messages > _this7.messageStart) {
          _this7.showMoreMessagesContainer.removeClass(hideClass);
        } else {
          _this7.showMoreMessagesContainer.addClass(hideClass);
        }

        if (loader) {
          loader.hide();
        }
      }).catch(function (error) {
        return _this7.options.events.onError(error);
      }).then(function () {
        if (_this7.options.preload.prerendered) {
          _this7.options.preload.prerendered = false;
        }
      });
    }
  }, {
    key: 'loadMessages',
    value: function loadMessages(messages) {
      var _this8 = this;

      if (!messages || messages.length === 0) {
        return;
      }

      messages.forEach(function (rootMessage) {
        var messageTemplate = _this8.options.preload.enabled && _this8.options.preload.prerendered ? _this8.options.messageContainer.find('[data-message-id=' + rootMessage.msg_id + ']') : null;

        var message = new Message(rootMessage, _this8, false, messageTemplate);

        if (Array.isArray(rootMessage.threadMsgs)) {
          rootMessage.threadMsgs.forEach(function (threadMessage) {
            var replyTemplate = _this8.options.preload.enabled && _this8.options.preload.prerendered ? _this8.options.messageContainer.find('[data-message-id=' + threadMessage.msg_id + ']') : null;

            var reply = new Message(threadMessage, _this8, true, replyTemplate);

            message.addReply(message.template.find(_this8.options.selectors.replies), reply);

            _this8.messageStart++;
          });
        }

        _this8.messageStart++;
        _this8.messages.push(message);
      });
    }
  }, {
    key: 'renderMessages',
    value: function renderMessages() {
      if (this.options.preload.enabled && this.options.preload.prerendered) {
        return;
      }

      if (this.options.showEmptyMessage) {
        var emptyMessage = jq(this.options.selectors.emptyMessage);

        if (!emptyMessage.length) {
          emptyMessage = jq(compiledEmptyMessageTemplate({
            T_: translate }));

          this.options.messageContainer.parent().append(emptyMessage);
        }

        if (this.messages.length) {
          emptyMessage.addClass(hideClass);
        } else {
          emptyMessage.removeClass(hideClass);
        }
      }

      var fragment = jq(document.createDocumentFragment());
      this.messages.forEach(function (message) {
        fragment.append(message.template);
      });

      this.options.messageContainer.append(fragment);
    }
  }, {
    key: 'bindMessageBoardEvents',
    value: function bindMessageBoardEvents() {
      var _this9 = this;

      jq(this.options.selectors.mainTextArea).off('keydown').keydown(function (event) {
        return onInputFieldKeydown(_this9, event, false);
      });

      this.options.messageBoardContainer.find(this.options.selectors.showMore).off('click').click(function (event) {
        return _this9.onShowMoreClick(event);
      });
    }
  }, {
    key: 'initializeHashTags',
    value: function initializeHashTags() {
      var _this10 = this;

      messageHashtags.init({
        enabled: this.options.messageHashtags.enabled,
        triggersEnabled: this.options.messageHashtags.triggersEnabled });

      if (this.options.contest.upgrades) {
        var upgradesKeys = Object.keys(this.options.contest.upgrades);
        if (upgradesKeys.length) {
          upgradesKeys.forEach(function (upgradeName) {
            if (_this10.options.contest.upgrades[upgradeName]) {
              messageHashtags.disableTag(upgradeName);
            }
          });
        }
      }

      messageHashtags.addTriggers(this.options.messageBoardContainer.find(this.options.selectors.pcbHashtagContainer));

      messageHashtags.on('triggerClicked', function (data) {
        var commentArea = jq(data.el).closest(_this10.options.selectors.commentForm).find('textarea');
        if (commentArea.length) {
          commentArea.val(commentArea.val() + ' #' + data.tag);
        }
      });

      messageHashtags.on('hashtagClicked', function (data) {
        _this10.options.events.onHashtagClick(data);
      });
    }
  }, {
    key: 'onShowMoreClick',
    value: function onShowMoreClick(event) {
      var target = jq(event.target).closest(this.options.selectors.pcbShowComments);

      var loader = target.find(this.options.selectors.viewMoreCommentLoader);
      loader.show();
      target.find('a').hide();
      this.populateMessageBoard(loader, false);
    }
  }, {
    key: 'postMessage',
    value: function postMessage(messageText, fileId, xCoordinate, yCoordinate) {
      var inputField = jq(this.options.selectors.mainTextArea);
      var messageData = {
        text: messageText,
        fileId: fileId,
        coordinates: {
          x: xCoordinate,
          y: yCoordinate } };

      return submitMessage(this, inputField, false, messageData).catch(function () {});
    }
  }, {
    key: 'findMessageByAnnotationId',
    value: function findMessageByAnnotationId(annotationId) {
      var messageObject = this.messages.find(function (message) {
        return parseInt(message.data.annotationId, 10) === parseInt(annotationId, 10);
      });

      return messageObject;
    }
  }, {
    key: 'updateMessageByAnnotationId',
    value: function updateMessageByAnnotationId(annotationId, newMessageText) {
      var messageObject = this.findMessageByAnnotationId(annotationId);

      if (!messageObject) {
        return Promise.reject(translate('Impossibile trovare messaggio da aggiornare'));
      }

      return messageObject.updateMessage(newMessageText);
    }
  }, {
    key: 'deleteMessageByAnnotationId',
    value: function deleteMessageByAnnotationId(annotationId) {
      var messageObject = this.findMessageByAnnotationId(annotationId);

      if (!messageObject) {
        return Promise.reject(translate('Impossibile trovare messaggio da eliminare'));
      }

      return messageObject.deleteMessage().catch(function () {});
    }
  }, {
    key: 'showAnnotationMarkers',
    value: function showAnnotationMarkers() {
      this.options.enableAnnotations = true;
      jq('.annotation-marker').removeClass('is-hidden');
    }
  }, {
    key: 'hideAnnotationMarkers',
    value: function hideAnnotationMarkers() {
      this.options.enableAnnotations = false;
      jq('.annotation-marker').addClass('is-hidden');
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.messages = [];
      this.messageStart = 0;

      this.options.messageContainer.empty();
    }
  }, {
    key: 'setEntryId',
    value: function setEntryId(entryId) {
      this.options.entry.id = entryId;
    }
  }, {
    key: 'disablePreload',
    value: function disablePreload() {
      this.options.preload.enabled = false;
    }
  }]);

  return MessageBoard;
}();

function onInputFieldKeydown(context, event, fromReply) {
  if (event.keyCode !== KEYCODE_ENTER || event.shiftKey) {
    return;
  }

  submitMessage(context, jq(event.target), fromReply).catch(function () {});
}

function submitMessage(context, input, fromReply, annotationData) {
  var errorMessage = translate('Impossibile inviare il tuo messaggio.');

  var messageData = Object.assign({}, {
    text: input.val(),
    parentId: fromReply ? context.data.msg_id : null }, annotationData);

  var board = fromReply ? context.parent : context;

  input.prop('disabled', true);
  input.parent().find(board.options.selectors.loadingOverlay).removeClass(hideClass);

  jq(board.options.selectors.pcbError).hide();

  return new Promise(function (resolve, reject) {
    postMessage(board, messageData).then(function (response) {
      if (response.success) {
        input.val('');

        var message = new Message(response.message, board, fromReply);

        if (fromReply) {
          message.template.hide();
          context.addReply(input.closest(board.options.selectors.comment).find(board.options.selectors.replies), message);

          input.closest(board.options.selectors.reply).addClass(hideClass);
        } else {
          message.template.hide().prependTo(board.options.messageContainer);
        }

        message.template.fadeIn('slow');

        board.messageStart++;
        board.messages.unshift(message);
        board.options.events.onMessagePosted(response.message);
        resolve(response.message);
      } else {
        if (Array.isArray(response.errors)) {
          errorMessage = response.errors.reduce(function (initial, value) {
            return initial + '\n' + value + '.';
          }, errorMessage);
        }

        if (response.errors && Array.isArray(response.errors.comment) && response.errors.comment.length) {
          errorMessage = response.errors.comment[0];
        }

        throw errorMessage;
      }
    }).catch(function (message) {
      board.options.events.onError(message);
      reject(message);
    }).then(function () {
      input.prop('disabled', false);
      input.parent().find(board.options.selectors.loadingOverlay).addClass(hideClass);
      board.options.events.onMessagePostingEnd();
    });
  });
}

function postMessage(board, messageData) {
  var data = {
    privacy: board.privacy,
    project_id: board.options.contest.id,
    comment: messageData.text };

  if (messageData.parentId) {
    data.parent_id = messageData.parentId;
  }

  if (board.options.entry.id) {
    data.entry_id = board.options.entry.id;
    data.to_user_id = board.options.toUser.id;

    if (board.options.entry.number) {
      data.entry_number = board.options.entry.number;
    }

    if (messageData.coordinates) {
      if (messageData.coordinates.x) {
        data.x_coordinate = messageData.coordinates.x;
      }

      if (messageData.coordinates.y) {
        data.y_coordinate = messageData.coordinates.y;
      }
    }

    if (messageData.fileId) {
      data.file_id = messageData.fileId;
    }
  }

  return messageApi.postMessage(data);
}

function getMessages(board, customParams, useCache) {
  return new Promise(function (resolve, reject) {
    if (useCache && board.options.preload.enabled) {
      return resolve(board.options.preload.messagesData);
    }

    var data = {
      project_id: board.options.contest.id };

    if (board.options.entry.id) {
      data.entry_id = board.options.entry.id;
    }

    var params = Object.assign({}, data, customParams);
    messageApi.getMessages(params).then(function (response) {
      return resolve(response);
    }).catch(function () {
      return reject(translate('Recupero dei messaggi non riuscito.'));
    });
  });
}

function onMessageDeleted(board, messageId) {
  var index = board.messages.findIndex(function (message) {
    return parseInt(message.data.msg_id, 10) === parseInt(messageId, 10);
  });

  if (index !== -1) {
    board.messages.splice(index, 1);
    board.messageStart--;
  }
}

function onMessageUpdated(board, messageId, messageJSON) {
  var index = board.messages.findIndex(function (message) {
    return parseInt(message.data.msg_id, 10) === parseInt(messageId, 10);
  });

  if (index !== -1) {
    var message = board.messages[index];
    message.data.formattedComment = messageJSON.formattedComment;
    message.data.formattedDate = messageJSON.formattedDate;
    message.data.timestamp = messageJSON.timestamp;
    board.messages.splice(index, 1);
    board.messages.unshift(message);
  }
}

var paymentsSourceTemplate = "<div class=\"payment-from\">\n    <div class=\"need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('Verrai reindirizzato alla pagina depositi per effettuare questo pagamento.') %>\n    </div>\n    <div class=\"may-need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('L’addebito verrà effettuato sui fondi disponibili nel tuo account e in seguito, se necessario, verrai reindirizzato alla pagina dei depositi per completare questo pagamento:') %>\n    </div>\n    <div class='form-only-balance only-balance payment-from-option' style=\"display:none\">\n        <%- T_('L’addebito verrà effettuato sui fondi disponibili nel tuo account:') %>\n    </div>\n    <%  if (templateData.firstAvailablePaymentMethod) {  %>\n        <div class=\"only-vpm payment-from-option\" style=\"display:none\">\n            <%  if (templateData.verifiedPaymentSourceCount == 1) {  %>\n                <%- T_('L’addebito verrà effettuato sul tuo metodo di pagamento verificato.') %>\n            <%  } else {  %>\n                <%- T_('L’addebito verrà effettuato sui tuo metodi di pagamento verificati.') %>\n            <%  }  %>\n            <%  if (templateData.showWireTransferLink) {  %>\n                <%= T_('Se preferisci pagare tramite bonifico bancario, clicca <a class=\"handover-wire-transfer-link\">qui</a> per piacere') %>\n            <%  }  %>\n        </div>\n        <div class=\"mixed-balance-vpm payment-from-option\" style=\"display:none\">\n            <%  if (templateData.verifiedPaymentSourceCount == 1) {  %>\n                <%- T_('L’importo verrà addebitato sui tuoi saldi disponibili e, se necessario, proveremo a elaborare il pagamento a partire dal tuo metodo di pagamento verificato:') %>\n            <%  } else {  %>\n                <%- T_('L’importo verrà addebitato sui tuoi saldi disponibili e, se necessario, proveremo a elaborare il pagamento a partire dai tuoi metodi di pagamento verificati:') %>\n            <%  }  %>\n        </div>\n    <%  }  %>\n    <p class=\"form-account-balance account-balances\" style=\"display:none\">\n        <strong><%- T_('Saldo del conto:') %></strong>\n        <%  if (templateData.balances) {  %>\n            <%  for (var i = 0; i < templateData.balances.length; i++) {  %>\n                <%-  templateData.balances[i].currency.sign  %><%-  templateData.balances[i].balance.toFixed(2)  %> <%-  templateData.balances[i].currency.code  %><%-  (i == templateData.balances.length - 1) ? '' : ','  %>\n            <%  }  %>\n        <%  }  %>\n    </p>\n</div>\n<%  if (templateData.firstAvailablePaymentMethod) {  %>\n    <div class=\"payment-logos-container\" style=\"display:none\">\n        <h6>\n            <%- T_('Metodo di pagamento verificato:') %>\n        </h6>\n\n        <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img-change-preferred-method margin-r20\" style=\"display:none\" />\n        <div class=\"payment-logo-container paypal gatewayPP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayPP') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-paypal\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container cc gatewayGC gatewayWP gatewayNAB gatewayAdyen\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayGC' && templateData.firstAvailablePaymentMethod != 'gatewayWP' && templateData.firstAvailablePaymentMethod != 'gatewayNAB' && templateData.firstAvailablePaymentMethod != 'gatewayAdyen') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-mastercard\"></span>\n            <span class=\"payment-icon-amex\"></span>\n            <span class=\"payment-icon-visa\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container skrill gatewayMB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayMB') {  %> style=\"display:none\" <%  }  %>>\n            <span class=\"payment-icon-skrill\"></span>\n        </div>\n        <div class=\"PaymentMethodSettings\">\n            <span class=\"showing-method-account-details gatewayPP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayPP') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.ppEmail) {  %>\n                    <%-  templateData.paymentMethods.ppEmail  %>\n                <%  } %>\n            </span>\n            <span class=\"showing-method-account-details gatewayWP\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayWP') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.wpRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.wpRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayWP margin-l20\"><%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.wpRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayNAB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayNAB') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.nabRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.nabRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayNAB margin-l20\"><%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.nabRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayAdyen\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayAdyen') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.adyenRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.adyenRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayAdyen margin-l20\"><%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.adyenRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <div class=\"payment-method-selector\">\n                <%  if (templateData.verifiedPaymentSourceCount > 1) {  %>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control open-change-preferred-method\">\n                        <%- T_('Modifica preferenze') %>\n                    </a>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control close-change-preferred-method\" style=\"display:none\">\n                        <%- T_('Annulla') %>\n                    </a>\n                    <span class=\"PaymentMethodSettings-control PaymentMethodSettings-control-separator\" <%  if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) {  %> style=\"display:none\" <%  }  %>> | </span>\n                <%  }  %>\n                <span class=\"PaymentMethodSettings-control is-PaymentMethodSettings-control-active\" <%  if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) {  %> style=\"display:none\" <%  }  %>><%- T_('Preferito') %></span>\n            </div>\n            <span class=\"showing-method-account-details gatewayGC\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayGC') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.gcRecurring.length == 1) {  %>\n                    <span class=\"margin-l20\"><%-  templateData.paymentMethods.gcRecurring[0]['cc_number']  %></span>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayGC margin-l20\"><%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.gcRecurring.length }) %></span>\n                <%  }  %>\n            </span>\n            <span class=\"showing-method-account-details gatewayMB\" <%  if (templateData.firstAvailablePaymentMethod != 'gatewayMB') {  %> style=\"display:none\" <%  }  %>>\n                <%  if (templateData.paymentMethods.skrillPaymentVerified.length == 1) {  %>\n                    <%- T_('ID ordine') %> <%-  templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id  %>\n                <%  } else {  %>\n                    <span class=\"payment-source-tooltip gatewayMB\"><%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length }) %></span>\n                <%  }  %>\n            </span>\n            <div class=\"clear\"></div>\n            <select class=\"default-select change-preferred-method\" style=\"display:none\">\n                <option value=\"\" selected=\"selected\"><%- T_('Seleziona il tuo metodo di pagamento preferito') %></option>\n                <%  if (templateData.paymentMethods.ppEmail) {  %>\n                    <option value=\"gatewayPP\"><%- T_('PayPal:') %> (<%-  templateData.paymentMethods.ppEmail  %>)</option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.gcRecurring) {  %>\n                    <option value=\"gatewayGC\"><%- T_('Carta di credito:') %>\n                        <%  if (templateData.paymentMethods.gcRecurring.length == 1) {  %>\n                            (<%-  templateData.paymentMethods.gcRecurring[0]['cc_number']  %>)\n                        <%  } else {  %>\n                            (<%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.gcRecurring.length }) %>)\n                        <%  }  %>\n                    </option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.wpRecurring) {  %>\n                    <option value=\"gatewayWP\"><%- T_('Carta di credito:') %>\n                    <%  if (templateData.paymentMethods.wpRecurring.length == 1) {  %>\n                        (<%-  templateData.paymentMethods.wpRecurring[0]['cc_number']  %>)\n                    <%  } else {  %>\n                        (<%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.wpRecurring.length }) %>)\n                    <%  }  %>\n                    </option>\n                <%  }  %>\n                <%  if (templateData.paymentMethods.skrillPaymentVerified) {  %>\n                    <option value=\"gatewayMB\"><%-  T_('Skrill:')  %>\n                    <%  if (templateData.paymentMethods.skrillPaymentVerified.length == 1) {  %>\n                        (<%- T_('ID ordine:') %> <%-  templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id  %>)\n                    <%  } else {  %>\n                        (<%= T_('<[-numberOfAccounts]> conti disponibili', { 'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length }) %>)\n                    <%  }  %>\n                    </option>\n                <%  }  %>\n            </select>\n        </div>\n        <div class=\"payments-source-generic-error margin-t10 alert alert-error\" style=\"display:none\"></div>\n    </div>\n<%  }  %>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-payments-source.js
 * Please replicate all changes to the other file.
 */

var moduleData = false;
var $el = false;
var moduleSettings = {
  disableCC: false,
  disableBalance: false,
  showWireTransferLink: false };

function init(paymentsSourceDetails, paymentsSourceContainer, preferredSettings) {
  jq.extend(moduleSettings, preferredSettings);

  if (typeof paymentsSourceDetails === 'object') {
    moduleData = paymentsSourceDetails;
  } else {
    return;
  }
  if (typeof paymentsSourceContainer !== 'undefined') {
    $el = paymentsSourceContainer;
  } else {
    return;
  }
  if (!validateAndPrepareData()) {
    return;
  }
  $el.html('<img src="' + cdn_url('/img/ajax-loader.gif') + '" ' + 'class="loading-payment-source-module margin-center block" />');

  jq.ajax({
    type: 'post',
    data: {
      currency: moduleData.currencyDetails.id },

    url: '/ajax/payment/getUserPaymentMethodInfo.php',
    dataType: 'json',
    success: function success(response) {
      if (response.status == 'success') {
        moduleData.balances = response.balances;
        moduleData.paymentMethods = response.paymentMethods;
        moduleData.firstAvailablePaymentMethod = response.firstAvailablePaymentMethod;
        moduleData.preferredPaymentMethod = response.preferredPaymentMethod;
        for (var i = 0; i < moduleData.balances.length; i++) {
          if (parseFloat(moduleData.balances[i].balance) > 0) {
            moduleData.totalBalanceIsEmpty = false;
            break;
          }
        }

        if (moduleSettings.disableCC) {
          removeCC();
        }

        if (moduleSettings.disableBalance) {
          removeBalance();
        }

        if (moduleSettings.showWireTransferLink) {
          includeWireTransferLink();
        }

        reconstructBalances();
        countVerifiedPaymentSource();
        render();
        buildBinds();
        checkPaymentSource(moduleData.amount);
      }
    },
    complete: function complete() {
      $el.find('.loading-payment-source-module').remove();
    }
  });
}

function removeCC() {
  moduleData.hasVerifiedCreditCard = moduleData.paymentMethods.gcRecurring || moduleData.paymentMethods.wpRecurring;
  moduleData.removedCC = true;
  moduleData.paymentMethods.gcRecurring = false;
  moduleData.paymentMethods.wpRecurring = false;

  moduleData.preferredPaymentMethod = 'gatewayPP';
  moduleData.firstAvailablePaymentMethod = 'gatewayPP';
}

function removeBalance() {
  moduleData.balances = [];
  moduleData.totalBalanceIsEmpty = true;
}

function includeWireTransferLink() {
  moduleData.showWireTransferLink = true;
}

function validateAndPrepareData() {
  if (typeof moduleData.amount === 'undefined' || Number.isNaN(moduleData.amount) || !moduleData.amount || typeof moduleData.currencyDetails === 'undefined') {
    return false;
  }
  moduleData.amount = parseFloat(moduleData.amount);
  moduleData.primaryBalanceForPayment = false;
  moduleData.totalBalanceIsEmpty = true;
  moduleData.verifiedPaymentSourceCount = 0;
  return true;
}

function render() {
  var tpl = paymentsSourceTemplate;

  if (typeof tpl === 'undefined') {
    tpl = jq('#payment-source-template').html();
  }

  $el.html(_.template(tpl)({
    templateData: moduleData,
    T_: translate,
    cdn_url: cdn_url }));
}

function checkPaymentSource(amountToCheck) {
  $el.find('.payment-from-option, .account-balances, .payment-logos-container').hide();
  if (Number.isNaN(amountToCheck) || !amountToCheck) {
    return;
  }

  amountToCheck = parseFloat(amountToCheck);

  if (moduleData.totalBalanceIsEmpty) {
    // If all balances are zero
    if (moduleData.firstAvailablePaymentMethod) {
      $el.find('.only-vpm, .payment-logos-container').show();
    } else {
      customizePaymentSourceNeedDepositContent();
      $el.find('.need-deposit').show();
    }
  } else if (moduleData.primaryBalanceForPayment && amountToCheck <= moduleData.primaryBalanceForPayment.balance) {
    // If primary balance is sufficient
    $el.find('.only-balance, .account-balances').show();
    // Primary balance is insufficient but not zero balances among all balances
  } else if (moduleData.firstAvailablePaymentMethod) {
    $el.find('.mixed-balance-vpm, .account-balances, .payment-logos-container').show();
  } else if (moduleData.balances.length === 1 && moduleData.balances[0].currency.id == moduleData.currencyDetails.id) {
    customizePaymentSourceNeedDepositContent();
    $el.find('.need-deposit').show();
  } else {
    $el.find('.may-need-deposit, .account-balances').show();
  }
}

function buildBinds() {
  jq(document).ready(function () {
    $el.off('change', '.change-preferred-method').on('change', '.change-preferred-method', function () {
      var that = jq(this);
      var method = that.val();
      if (!method) {
        return;
      }
      var existingMethod = $el.find('.payment-logo-container:visible, ' + '.showing-method-account-details:visible');

      jq.ajax({
        url: '/ajax/user/setUserPreferedPayment.php',
        dataType: 'json',
        type: 'post',
        data: {
          method: method },

        beforeSend: function beforeSend() {
          that.hide();
          $el.find('.payment-logo-container, .close-change-preferred-method, ' + '.showing-method-account-details').hide();
          $el.find('.loading-img-change-preferred-method, ' + '.open-change-preferred-method').show();
          $el.find('.payments-source-generic-error').html('').hide();
          $el.closest('.modal').find('.btn').attr('disabled', true);
        },
        success: function success(response) {
          if (response.result == 'success') {
            $el.find('.is-preferred, .is-preferred-separator, ' + ('.payment-logo-container.' + method + ', ') + ('.showing-method-account-details.' + method)).show();
            moduleData.preferredPaymentMethod = method;
          } else {
            $el.find('.payments-source-generic-error').html(translate('Impossibile registrare il tuo metodo di pagamento preferito. Riprova per piacere.')).show();
            existingMethod.show();
          }
        },
        error: function error() {
          $el.find('.payments-source-generic-error').html(translate('Errore del server')).show();
          existingMethod.show();
        },
        complete: function complete() {
          $el.find('.loading-img-change-preferred-method').hide();
          // front end delay for potential slave drift
          setTimeout(function () {
            $el.closest('.modal').find('.btn').removeAttr('disabled');
          }, 1200);
        }
      });
    });

    $el.off('click', '.open-change-preferred-method').on('click', '.open-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.is-preferred').hide();
      $el.find('.change-preferred-method, .close-change-preferred-method').show();
    });

    $el.off('click', '.close-change-preferred-method').on('click', '.close-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.change-preferred-method').hide();
      if (moduleData.preferredPaymentMethod) {
        $el.find('.is-preferred').show();
      }
      $el.find('.open-change-preferred-method').show();
    });

    $el.find('.payment-source-tooltip.gatewayGC').popover({
      content: function content() {
        var gatewayGCAccounts = [];
        if (moduleData.paymentMethods.gcRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.gcRecurring.length; i++) {
            gatewayGCAccounts.push(moduleData.paymentMethods.gcRecurring[i].cc_number);
          }
        }
        return gatewayGCAccounts.join('<br>');
      },

      title: 'Credit cards',
      placement: 'top',
      html: true,
      trigger: 'hover' });

    $el.find('.payment-source-tooltip.gatewayWP').popover({
      content: function content() {
        var gatewayWPAccounts = [];
        if (moduleData.paymentMethods.wpRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.wpRecurring.length; i++) {
            gatewayWPAccounts.push(moduleData.paymentMethods.wpRecurring[i].cc_number);
          }
        }
        return gatewayWPAccounts.join('<br>');
      },

      title: translate('Carte di credito'),
      placement: 'top',
      html: true,
      trigger: 'hover' });

    $el.find('.payment-source-tooltip.gatewayMB').popover({
      content: function content() {
        var gatewayMBAccounts = [];
        if (moduleData.paymentMethods.skrillPaymentVerified) {
          for (var i = 0; i < moduleData.paymentMethods.skrillPaymentVerified.length; i++) {
            gatewayMBAccounts.push(moduleData.paymentMethods.skrillPaymentVerified[i].onetap_invoice_id);
          }
        }
        return gatewayMBAccounts.join('<br>');
      },

      placement: 'top',
      html: true,
      trigger: 'hover' });
  });
}

function reconstructBalances() {
  // Remove balances with zero amount and set the primary balance to balance
  // with payment's currency
  for (var i = 0; i < moduleData.balances.length;) {
    moduleData.balances[i].balance = parseFloat(moduleData.balances[i].balance);
    if (moduleData.balances[i].balance == 0) {
      moduleData.balances.splice(i, 1);
    } else if (moduleData.balances[i].currency.id == moduleData.currencyDetails.id) {
      moduleData.primaryBalanceForPayment = moduleData.balances[i];
      moduleData.balances.splice(i, 1);
    } else {
      i++;
    }
  }
  if (moduleData.primaryBalanceForPayment) {
    moduleData.balances.unshift(moduleData.primaryBalanceForPayment);
  }
}

function countVerifiedPaymentSource() {
  if (moduleData.firstAvailablePaymentMethod) {
    if (moduleData.paymentMethods.ppEmail) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.gcRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.wpRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.skrillPaymentVerified) {
      moduleData.verifiedPaymentSourceCount++;
    }
  }
}

function customizePaymentSourceNeedDepositContent() {
  if (typeof moduleData.needDepositCustomTitle !== 'undefined') {
    $el.closest('.modal').find('.modal-header h3').html(moduleData.needDepositCustomTitle);
  }

  if (typeof moduleData.needDepositCustomBody !== 'undefined') {
    $el.find('.need-deposit').html(moduleData.needDepositCustomBody);
  }
  if (typeof moduleData.needDepositAmountDiv !== 'undefined' && !moduleData.needDepositAmountDiv) {
    $el.find('.payment-from').hide();
    $el.closest('.modal-body').find('p:first').hide();
  }

  if (typeof moduleData.needDepositConfirmText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-confirm-payment').html(moduleData.needDepositConfirmText);
  }
  if (typeof moduleData.needDepositCancelText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-cancel-payment').html(moduleData.needDepositCancelText);
  }
}

var modulePaymentsSource = {
  init: init,
  checkPaymentSource: checkPaymentSource };

var fixedAmountPaymentModalTemplate = "<div class=\"modal-header\">\n    <a class=\"close\" data-dismiss=\"modal\">&times;</a>\n    <h3><%-  customizedModal.title  %></h3>\n</div>\n<div class=\"modal-body\">\n\n    <%  if (customizedModal.description != '') {  %>\n        <p class=\"margin-b20\">\n            <%=  customizedModal.description  %>\n        </p>\n    <%  }  %>\n\n    <%  if (!customizedModal.showDescriptionOnly) {  %>\n        <p class=\"margin-b20\">\n            <strong><%- T_('Importo da pagare:') %></strong> <%-  templateData.currencyDetails.sign  %><%-  templateData.amount.toFixed(2)  %> <%-  templateData.currencyDetails.code  %>\n            <span class='muted'> <%-  customizedModal.chargeDetail  %> </span>\n        </p>\n        <div class=\"payment-sources-container\">\n        </div>\n    <%  }  %>\n    <%  if (typeof customizedModal.additionalDetails != 'undefined') {  %>\n        <p class=\"margin-b20 margin-t10\">\n            <%=  customizedModal.additionalDetails  %>\n        </p>\n    <%  }  %>\n\n    <div class=\"alert alert-error modal-milestone-generic-error regular\" style=\"display:none\"></div>\n\n</div>\n<div class=\"modal-footer\">\n    <%  if (customizedConfirm.show) {  %>\n        <button type=\"button\" class=\"btn btn-info btn-small modal-btn-confirm-payment\"><%-  customizedConfirm.buttonText  %></button>\n    <%  }  %>\n    <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"loading-img margin-r20\" style=\"display:none\"/>\n    <%  if (customizedCancel.show) {  %>\n        <button type=\"button\" class=\"btn btn-small modal-btn-cancel-payment\"><%-  customizedCancel.buttonText  %></button>\n    <%  }  %>\n</div>\n";

var newFixedAmountPaymentModalTemplate = "<div class=\"responsive-modal\" id=\"expanded-payment-modal\">\n    <div class=\"modal ModalPayment\" aria-label=\"<%- T_('Chiudi') %>\" data-backdrop=\"true\">\n        <div class=\"modal-header ModalPayment-header\">\n            <button id=\"paymentModalCloseButton\" type=\"button\" class=\"payment-modal-close close\" data-dismiss=\"modal\" aria-label=\"<%- T_('Chiudi') %>\">\n                <span class=\"Icon Icon--small\">\n                    <%=  uiIcon('ui-close-alt')  %>\n                </span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <div class=\"ModalPayment-body\">\n                <figure class=\"ModalPayment-figure\">\n                    <img class=\"ModalPayment-image\" src=\"<%=  cdn_url('/static/img/secure-payment.png')  %>\" alt=\"<%- T_('Pagamento sicuro') %>\" />\n                </figure>\n                <div class=\"ModalPayment-heading\"><%-  heading  %></div>\n                <%  if (headingSubtext) {  %>\n                    <div class=\"ModalPayment-headingSubtext\"><%-  headingSubtext  %></div>\n                <%  }  %>\n                <%  if (subHeading) {  %>\n                    <div class=\"ModalPayment-subHeading\"><%-  subHeading  %></div>\n                <%  }  %>\n                <%  if (showCharges) {  %>\n                    <%  for (i = 0; i < chargeDetails.length; i++) {  %>\n                        <%  if (parseFloat(chargeDetails[i].amount) > 0) {  %>\n                            <div class=\"ModalPayment-paymentDetails\">\n                                <div class=\"ModalPayment-label\">\n                                    <%=  chargeDetails[i].label  %>\n                                </div>\n                                <div class=\"ModalPayment-price\">\n                                    <span class=\"ModalPayment-totalCost-price\">\n                                        <%  if (chargeDetails[i].paid) {  %>\n                                            <span class=\"ModalPayment-totalCost-price-paid\">\n                                                <%- T_('PAGATO') %>\n                                            </span>\n                                        <%  } else {  %>\n                                            <%-  currency.sign  %><%-  chargeDetails[i].amount.toFixed(2)  %>\n                                        <%  }  %>\n                                    </span>\n                                </div>\n                            </div>\n                        <%  }  %>\n                    <%  }  %>\n                    <div class=\"ModalPayment-totalCost\">\n                        <span class=\"ModalPayment-totalCost-label\"><%- T_('Totale:') %></span>\n                        <span class=\"ModalPayment-totalCost-price\">\n                            <%-  currency.sign  %><%-  chargeTotal.toFixed(2)  %> <%-  currency.code  %>\n                        </span>\n                        <%  if (includesGST) {  %>\n                            <div class=\"ModalPayment-totalCost-detail\"><%- T_('GST inclusa') %></div>\n                        <%  } else if (taxName) {  %>\n                            <div class=\"ModalPayment-totalCost-detail\"><%- T_('inclusa') %> <%-  taxName  %></div>\n                        <%  }  %>\n                    </div>\n                <%  }  %>\n                <%  if (text) {  %>\n                    <p class=\"ModalPayment-descriptionText\"><%=  text  %></p>\n                <%  }  %>\n            </div>\n            <div class=\"ModalPayment-footer\n                <%  if (!footerText) {  %>\n                    ModalPayment-footer-noText\n                <%  }  %>\n            \">\n                <%  if (footerText) {  %>\n                    <p><%-  footerText  %></p>\n                <%  }  %>\n                <button id=\"paymentModalConfirmButton\" class=\"btn btn-large btn-success ModalPayment-footer-btn\"><%-  buttonLabel  %></button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-fixed-amount-payment-modal.js
 * Please replicate all changes to the other file.
 */

/*
                                                                                                  Usage:
                                                                                                  For bootstrap page:
                                                                                                    1. Require the module in your javascript file
                                                                                                    2. Call module.initModal(paymentDetails)
                                                                                                  For non-bootstrap page:
                                                                                                    1. Call initFixedAmountPaymentModalOnNonBSPage(paymentDetails) --
                                                                                                       lack of template, not supported yet
                                                                                                  
                                                                                                  @compulsory params
                                                                                                  paymentDetails is an object contains
                                                                                                    Compulsory:
                                                                                                      amount -- amount for checking payment source
                                                                                                      currencyDetails(id, sign, code) -- object with id, sign, code
                                                                                                  
                                                                                                  @optional params
                                                                                                  callbackFn is a callback function for 'Confirm' button
                                                                                                  callbackFnParams is an object contains params for callbackFn
                                                                                                  cancelCallbackFn is a callback function for 'cancel' button
                                                                                                  cancelCallbackFn is an object contains params for cancelCallbackFn
                                                                                                  customizedConfirmDetails is an object contains customized copies, etc for
                                                                                                  'Confirm' button
                                                                                                  customizedCancelDetails is an object contains customized copies, etc for
                                                                                                  'Cancel' button
                                                                                                  These are optional params, please precheck these params
                                                                                                  (eg. null/undefined/false) in the module/template to avoid unexpected errors
                                                                                                  */

var modalVars = {};

function initModalVars(scope) {
  scope.moduleData = {};
  scope.$el = false;
  scope.callback = false;
  scope.callbackParams = false;
  scope.cancelCallback = false;
  scope.cancelCallbackParams = false;
  scope.closeCallback = false;
  scope.closeCallbackParams = false;
  scope.confirmConfig = {
    buttonText: translate('Conferma il pagamento'),
    show: true };

  scope.cancelConfig = {
    buttonText: translate('Annulla'),
    show: true };

  scope.customizedConfirm = scope.confirmConfig;
  scope.customizedCancel = scope.cancelConfig;

  scope.customizedModal = {
    title: translate('Autorizza pagamento'),
    description: '',
    chargeDetail: '',
    showDescriptionOnly: false };
}

function buildBinds$1() {
  jq(document).ready(function () {
    modalVars.$el.off('click', '.modal-btn-confirm-payment').on('click', '.modal-btn-confirm-payment', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.callback === 'function') {
        modalVars.callback(modalVars.callbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'ConfirmPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });

    modalVars.$el.off('click', '.modal-btn-cancel-payment').on('click', '.modal-btn-cancel-payment', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.cancelCallback === 'function') {
        modalVars.cancelCallback(modalVars.cancelCallbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'CancelPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });

    modalVars.$el.on('click', '.modal-header .close', function () {
      if (typeof modalVars.closeCallback === 'function') {
        modalVars.closeCallback(modalVars.closeCallbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'CloseModal',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });
  });
}

function buildBindsForExpandedModal() {
  jq(document).ready(function () {
    modalVars.$el.off('click', '#paymentModalConfirmButton').on('click', '#paymentModalConfirmButton', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.callback === 'function') {
        modalVars.callback(modalVars.callbackParams);
      }
      _t.push(['user_action', {
        section: 'ExpandedPaymentConfirmationModal',
        label: 'ConfirmPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });

    modalVars.$el.on('click', '#paymentModalCloseButton', function () {
      if (typeof modalVars.closeCallback === 'function') {
        modalVars.closeCallback(modalVars.closeCallbackParams);
      }
      _t.push(['user_action', {
        section: 'ExpandedPaymentConfirmationModal',
        label: 'CloseModal',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id }]);

      return false;
    });
  });
}

function initModal(paymentDetails, callbackFn, callbackFnParams, cancelCallbackFn, cancelCallbackFnParams, customizedConfirmDetails, customizedCancelDetails, customizedModalDialog, closeCallbackFn, closeCallbackFnParams, useExpandedModal) {
  initModalVars(modalVars);

  if (typeof callbackFn === 'function') {
    modalVars.callback = callbackFn;
  }
  if (typeof callbackFnParams === 'object') {
    modalVars.callbackParams = callbackFnParams;
  }
  if (typeof cancelCallbackFn === 'function') {
    modalVars.cancelCallback = cancelCallbackFn;
  }
  if (typeof cancelCallbackFnParams === 'object') {
    modalVars.cancelCallbackParams = cancelCallbackFnParams;
  }
  if (typeof closeCallbackFn === 'function') {
    modalVars.closeCallback = closeCallbackFn;
  }
  if (typeof closeCallbackFnParams === 'object') {
    modalVars.closeCallbackParams = closeCallbackFnParams;
  }
  if (typeof customizedConfirmDetails === 'object') {
    modalVars.customizedConfirm = customizedConfirmDetails;
    if (typeof modalVars.customizedConfirm.buttonText === 'undefined') {
      modalVars.customizedConfirm.buttonText = modalVars.confirmConfig.buttonText;
    }
    if (typeof modalVars.customizedConfirm.show === 'undefined') {
      modalVars.customizedConfirm.show = modalVars.confirmConfig.show;
    }
  }
  if (typeof customizedCancelDetails === 'object') {
    modalVars.customizedCancel = customizedCancelDetails;
    if (typeof modalVars.customizedCancel.buttonText === 'undefined') {
      modalVars.customizedCancel.buttonText = modalVars.cancelConfig.buttonText;
    }
    if (typeof modalVars.customizedCancel.show === 'undefined') {
      modalVars.customizedCancel.show = modalVars.cancelConfig.show;
    }
  }
  if (typeof customizedModalDialog === 'object') {
    modalVars.customizedModal = jq.extend(modalVars.customizedModal, customizedModalDialog);
  }
  if (typeof paymentDetails === 'object') {
    modalVars.moduleData = paymentDetails;
  } else {
    return;
  }
  if (validateAndPrepareData$1()) {
    if (modalVars.moduleData.amount > 0) {
      if (typeof useExpandedModal !== 'undefined' && useExpandedModal) {
        renderExpandedModal();
      } else {
        renderModal();
      }
    } else if (typeof modalVars.callback === 'function') {
      modalVars.callback(modalVars.callbackParams);
    }
  }
}

function validateAndPrepareData$1() {
  if (typeof modalVars.moduleData.amount === 'undefined' || typeof modalVars.moduleData.currencyDetails === 'undefined' || modalVars.customizedModal.showDescriptionOnly && modalVars.customizedModal.description === '') {
    return false;
  }
  modalVars.moduleData.amount = parseFloat(modalVars.moduleData.amount);
  if (Number.isNaN(modalVars.moduleData.amount) || modalVars.moduleData.amount < 0) {
    return false;
  }
  return true;
}

function renderModal() {
  var mainContainer = void 0;
  if (jq('.gaf-container').length > 0) {
    mainContainer = '.gaf-container:first';
  } else {
    mainContainer = '.pinky-template:first';
  }

  /**
     * When you have a page that has both `.gaf-container` and `.pinky-template`,
     * but want to force this payment modal to be appended
     * inside a `.pinky-template` container,
     * just set `usePinkyTemplateContainer` to `true`
     * in the first object argument of `initModal`.
     */
  if (typeof modalVars.moduleData.usePinkyTemplateContainer !== 'undefined' && modalVars.moduleData.usePinkyTemplateContainer === true) {
    mainContainer = '.pinky-template:first';
  }
  modalVars.$el = jq('.fixed-amount-payment-modal');
  modalVars.$el.modal('hide').remove();
  modalVars.$el = jq('<div class="fixed-amount-payment-modal modal hide"></div>').appendTo(mainContainer);
  modalVars.$el.html(_.template(fixedAmountPaymentModalTemplate)({
    templateData: modalVars.moduleData,
    customizedConfirm: modalVars.customizedConfirm,
    customizedCancel: modalVars.customizedCancel,
    customizedModal: modalVars.customizedModal,
    T_: translate,
    cdn_url: cdn_url }));

  modulePaymentsSource.init(modalVars.moduleData, modalVars.$el.find('.payment-sources-container'));

  buildBinds$1();
  modalVars.$el.modal({
    backdrop: 'static',
    keyboard: true });
}

function renderExpandedModal() {
  var mainContainer = void 0;
  if (jq('.gaf-container').length > 0) {
    mainContainer = '.gaf-container:first';
  } else {
    mainContainer = '.pinky-template:first';
  }

  if (typeof modalVars.moduleData.usePinkyTemplateContainer !== 'undefined' && modalVars.moduleData.usePinkyTemplateContainer === true) {
    mainContainer = '.pinky-template:first';
  }
  modalVars.$el = jq('.fixed-amount-payment-modal');
  modalVars.$el.modal('hide').remove();
  modalVars.$el = jq('<div class="fixed-amount-payment-modal hide"></div>').appendTo(mainContainer);
  modalVars.$el.html(_.template(newFixedAmountPaymentModalTemplate)({
    heading: translate('Conferma il pagamento'),
    headingSubtext: modalVars.moduleData.headingSubtext,
    subHeading: translate('Aggiornamenti'),
    buttonLabel: translate('Conferma il pagamento'),
    showCharges: true,
    chargeDetails: modalVars.moduleData.chargeDetails,
    chargeTotal: modalVars.moduleData.amount,
    currency: modalVars.moduleData.currencyDetails,
    includesGST: modalVars.moduleData.includesGST,
    taxName: modalVars.moduleData.taxName,
    text: null,
    footerText: translate('L\'importo verrà addebitato sui tuoi saldi disponibili e, se necessario, proveremo a elaborare il pagamento a partire dai tuoi metodi di pagamento verificati.'),

    templateData: modalVars.moduleData,
    customizedConfirm: modalVars.customizedConfirm,
    customizedCancel: modalVars.customizedCancel,
    customizedModal: modalVars.customizedModal,
    T_: translate,
    uiIcon: uiIcon,
    cdn_url: cdn_url }));

  buildBindsForExpandedModal();
  modalVars.$el.modal({
    backdrop: 'static',
    keyboard: true });
}

function getModal() {
  return modalVars.$el;
}

var fixedAmountPaymentModalModule = {
  initModal: initModal,
  getModal: getModal };

var editEntryTemplate = "<!-- modal begins-->\n<div id=\"edit-entry-modal\" class=\"edit-entry-modal modal hide\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"myModalLabel\" aria-hidden=\"true\">\n  <div class=\"modal-header\">\n    <h3>\n      <%  if (price && price > 0) {  %>\n        <%- T_('Modifica prezzo') %>\n      <%  } else {  %>\n        <%- T_('Vendi proposta') %>\n      <%  }  %>\n    </h3>\n  </div>\n  <div class=\"pinky-template\" data-load=\"forms/default-form\">\n    <form class=\"fl-form\" onsubmit=\"return false;\">\n      <div class=\"modal-body\">\n        <div class='form-errors alert alert-error hide'>\n        </div>\n        <input type='hidden' name=\"id\"\n          id=\"input-id\" value='<%-  id  %>'>\n        <div class='sell-instructions'>\n          <%- T_(\"Fissa un prezzo per la tua proposta e se non vinci, avrai un’altra possibilità affinché il titolare del concorso compri la tua proposta!\") %>\n        </div>\n        <strong class=\"input-price-label\">\n          <%- T_(\"Prezzo di vendita della proposta:\") %>\n        </strong>\n        <span class=\"input-group input-group-price\">\n          <span class=\"add-on\"><%-  symbol  %></span>\n          <input id=\"input-price\" class=\"addoned-field default-input\"\n            name=\"price\"\n            value='<%-  price  %>' type=\"text\"\n            min=\"1\" max=\"<%-  prize  %>\">\n          <span class=\"add-on\"><%-  code  %></span>\n        </span>\n      </div>\n      <div class=\"modal-footer\">\n        <button id=\"contest-entry-edit-confirm\" class=\"btn btn-info\" aria-hidden=\"true\">\n          <%- T_(\"Conferma\") %>\n        </button>\n        <button class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\"><%- T_(\"Annulla\") %>\n        </button>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- modal ends-->\n";

var buyEntryTemplate = "<%= T_(\"Sei sicuro di voler comprare la proposta #<[- number ]> di <a title='<[- username ]>' href='/u/<[- username ]>'><[- publicUserName ]></a>?\", {\n  username: username,\n  number: number,\n  publicUserName: publicUserName }) %>\n<div style=\"text-align: center\"><img src=\"<%-  thumb  %>\"></div>\n";

var _templateObject$3 = _taggedTemplateLiteral(['Inserisci un importo compreso tra ', ' e ', ''], ['Inserisci un importo compreso tra ', ' e ', '']);

var entryApi = new EntryApi();
var compiledEditEntryTemplate = template(editEntryTemplate);
var compiledBuyEntryTemplate = template(buyEntryTemplate);

var SellEntry = function () {
  function SellEntry() {
    _classCallCheck(this, SellEntry);

    this.options = {
      enabled: true,
      entry: {
        id: null,
        sell_price: 0 },

      container: jq('.contest-entry-wrapper'),
      modalContainer: jq('#contest-response-container'),
      minSellPrice: 0,
      prize: 10,
      currency: {
        code: 'USD',
        sign: '$' } };
  }

  _createClass(SellEntry, [{
    key: 'init',
    value: function init(options) {
      var _this = this;

      this.options = Object.assign({}, this.options, options);

      if (!this.options.enabled) {
        return;
      }

      this.options.container.off('click', '.entry-edit-price');
      this.options.container.on('click', '.entry-edit-price', function (event) {
        event.preventDefault();
        _this.openEditModal();
      });
    }
  }, {
    key: 'openEditModal',
    value: function openEditModal() {
      var _this2 = this;

      var data = {
        T_: translate,
        symbol: this.options.currency.sign,
        code: this.options.currency.code,
        id: this.options.entry.id,
        price: this.options.entry.sell_price,
        prize: this.options.prize };

      this.options.modalContainer.find('#edit-entry-modal').remove();
      this.options.modalContainer.append(compiledEditEntryTemplate(data));

      this.editPriceModal = this.options.modalContainer.find('#edit-entry-modal');

      var form = this.editPriceModal.find('.fl-form');
      form.validate({
        rules: {
          id: {
            required: true },

          price: {
            required: true,
            digits: true,
            range: [this.options.minSellPrice, this.options.prize] } },

        errorPlacement: function errorPlacement() {
          return true;
        } });

      this.editPriceModal.off('click', '#contest-entry-edit-confirm');
      this.editPriceModal.on('click', '#contest-entry-edit-confirm', function () {
        _this2.submitEdit();
      });

      this.editPriceModal.modal('show');
    }
  }, {
    key: 'submitEdit',
    value: function submitEdit() {
      var _this3 = this;

      var modal = this.editPriceModal;
      modal.find('button').prop('disabled', true);

      var form = modal.find('.fl-form');

      if (form.valid()) {
        (function () {
          var data = {
            entry_id: _this3.options.entry.id,
            sell_price: form.find('#input-price').val() };

          entryApi.editEntryPrice(data).then(function (response) {
            if (response) {
              if (response.status === 'success') {
                _this3.options.entry.sell_price = data.sell_price;
                modal.modal('hide');
              } else {
                modal.find('.form-errors').show();
                modal.find('.form-errors').html(response.errors);
                modal.find('button').removeAttr('disabled');
              }
            }
          }).catch(function () {
            modal.find('.form-errors').show();
            modal.find('.form-errors').html(translate('Impossibile modificare il prezzo.'));
            modal.find('button').removeAttr('disabled');
          });
        })();
      } else {
        var min = '' + this.options.currency.sign + this.options.minSellPrice;
        var max = '' + this.options.currency.sign + this.options.prize;
        modal.find('.form-errors').show();
        modal.find('.form-errors').html(translate(_templateObject$3, min, max));
        modal.find('button').prop('disabled', false);
      }
    }
  }, {
    key: 'openBuyEntryModal',
    value: function openBuyEntryModal(data) {
      var _this4 = this;

      var paymentsSourceDetails = {
        amount: data.sellPrice,
        currencyDetails: {
          id: data.currency.id,
          sign: data.currency.sign,
          code: data.currency.code } };

      var confirmDetails = {
        show: true,
        buttonText: translate('Compra subito') };

      var cancelDetails = {
        show: true,
        buttonText: translate('Annulla') };

      var modalContent = {
        description: compiledBuyEntryTemplate({
          T_: translate,
          username: data.username,
          publicUserName: data.publicUserName,
          number: data.number,
          thumb: data.thumb }) };

      fixedAmountPaymentModalModule.initModal(paymentsSourceDetails, function () {
        return _this4.buyEntry(data);
      }, null, null, null, confirmDetails, cancelDetails, modalContent);

      return fixedAmountPaymentModalModule.getModal();
    }
  }, {
    key: 'buyEntry',
    value: function buyEntry(callbackData) {
      var data = {
        entry_id: callbackData.entryId,
        isAjax: true };

      entryApi.buy(data).then(function (response) {
        if (response.result === 'redirect') {
          window.location.href = response.redirect;
        } else {
          showErrorModal(translate('Impossibile acquistare la proposta, riprova per piacere.'));
        }
      }).catch(function () {
        showErrorModal(translate('Errore del server. Impossibile acquistare la proposta.'));
      });
    }
  }]);

  return SellEntry;
}();

var contestsInterestedInTemplate = "<div class=\"span4 contest-related-wrapper dataList FeatureFlag-search\">\n  <div class=\"contest-related-items dataList-set\">\n    <h5 class=\"contest-related-items-title dataList-header\"><%= T_('Concorsi simili') %></h5>\n    <div class=\"dataList-items\">\n      <%  contestsInterestedIn.forEach(function(contest) {  %>\n        <div class=\"contest-related-item dataList-item\">\n          <span class=\"contest-related-item-title dataList-authorLink\">\n            <a href=\"<%-  contest.seoUrl  %>\">\n              <%-  contest.project_name  %>\n            </a>\n          </span>\n          <span class=\"contest-related-item-author dataList-itemAuthor\">\n            <%  if (loggedIn) {  %>\n              <a href=\"<%-  contest.user_info.url  %>\">\n                <%= T_('di <[- uname ]>', { uname: contest.user_info.publicName }) %>\n              </a>\n            <%  } else {  %>\n              <span>\n                <%= T_('di <[- uname ]>', { uname: contest.user_info.publicName }) %>\n              </span>\n            <%  }  %>\n          </span>\n          <span class=\"contest-related-item-value dataList-itemPrice\">\n            $<%-  contest.bid_avg_usd  %> USD\n          </span>\n        </div>\n      <%  });  %>\n      <a class=\"contest-related-more dataList-link\" href=\"/jobs/j-contest-t-featured/\">\n        <%= T_('Mostra altro') %>\n      </a>\n    </div>\n  </div>\n  <div class=\"contest-related-items dataList-set\">\n    <h5 class=\"contest-related-items-title dataList-header\"><%= T_('Concorsi completati') %></h5>\n    <div class=\"dataList-items\">\n      <%  completedContests.forEach(function(contest) {  %>\n        <div class=\"contest-related-item dataList-item\">\n          <span class=\"contest-related-item-title dataList-authorLink\">\n            <a href=\"<%-  contest.contestURL  %>\">\n              <%-  contest.contest_name  %>\n            </a>\n          </span>\n          <span class=\"contest-related-item-author dataList-itemAuthor\">\n            <%  if (loggedIn) {  %>\n              <a href=\"/u/<%-  contest.username  %>\">\n                <%= T_('di <[- uname ]>', { uname: contest.publicUserName }) %>\n              </a>\n            <%  } else {  %>\n              <span>\n                <%= T_('di <[- uname ]>', { uname: contest.publicUserName }) %>\n              </span>\n            <%  }  %>\n          </span>\n          <span class=\"contest-related-item-value dataList-itemPrice\">\n            $<%-  contest.prizeInUSD  %> USD\n          </span>\n        </div>\n      <%  });  %>\n    </div>\n  </div>\n</div>\n";

var templateInterestedIn = template(contestsInterestedInTemplate);
var contestApi = new ContestApi();

function init$1() {
  var container = document.getElementById('contestViewContainer');
  var projectId = container.getAttribute('data-contest-id');
  getContestsInterestedIn(projectId).then(function (data) {
    data.T_ = translate;
    var target = document.getElementById('contests-related-container');
    target.innerHTML += templateInterestedIn(data);
  });
}

function getContestsInterestedIn(projectId) {
  return contestApi.getContestsInterestedIn({
    project_id: projectId
  }).then(function (response) {
    if (response.status !== 'fail') {
      // FIXME: getContestsInterestedIn API inconsistently
      // returns a {} and an []. Below is a workaround.
      response.contestsInterestedIn = Object.keys(response.contestsInterestedIn).map(function (key) {
        return response.contestsInterestedIn[key];
      });

      return response;
    }
  });
}

var webappTrackingServiceReady = new Promise(function (resolve) {
  if (window.webappCompatTracking) {
    resolve();
  } else {
    window.webappCompatTrackingReadyCallback = function () {
      return resolve();
    };
  }
});

var Tracking = {
  trackCustomEvent: function trackCustomEvent(name, section, extraParams) {
    return webappTrackingServiceReady.then(function () {
      return window.webappCompatTracking.trackCustomEvent(name, section, extraParams);
    });
  }
};

var tutorialModalTemplate = "<div class=\"Modal Modal--small MultiAwardModal confirm-award\">\n    <div class=\"Modal-inner\">\n        <div class=\"Modal-dialog\">\n            <div class=\"Modal-content Card\">\n                <button id=\"award-tutorial-close\" class=\"Modal-close\" type=\"button\" data-dismiss=\"modal\" data-modal-hide aria-label=\"<%- T_('Chiudi questa finestra modale') %>\">\n                    <span class=\"Icon Icon--small\">\n                        <%=  uiIcon('ui-close')  %>\n                    </span>\n                </button>\n                <div class=\"Modal-body\">\n                    <div class=\"MultiAwardModal-content\">\n                        <h5 class=\"MultiAwardModal-heading\">\n                            <%- T_('Seleziona questa proposta') %>\n                        </h5>\n                        <div class=\"contest-item-picked\">\n                            <figure class=\"MultiAwardModal-figure\">\n                                <img alt=\"<%- T_('Selezionare come vincitore?') %>\" class=\"MultiAwardModal-image\" src=\"<%-  entry.thumb420  %>\">\n                            </figure>\n                        </div>\n                        <p class=\"MultiAwardModal-desc\">\n                            <%- T_('Assegnare il premio a <[- user ]> per la proposta #<[- number ]>?', { 'user': entry.publicUserName, 'number': entry.number }) %>\n                        </p>\n                        <div class=\"MultiAwardModal-cta\">\n                            <button type=\"button\" id=\"award-single-entry\" class=\"btn btn-block btn-info\"><%- T_('Seleziona ora') %></button>\n                        </div>\n                        <div class=\"MultiAwardModal-textBreak\"><%- T_('o') %></div>\n                        <button id=\"award-multiple-entries\" class=\"btn btn-link\"><%- T_('Seleziona più di un vincitore per questo concorso') %></button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

var selectors = {
  awardSingleEntry: '#award-single-entry',
  awardMultipleEntries: '#award-multiple-entries',
  closeButton: '#award-tutorial-close'
};

var MultiAwardTutorialModal = function () {
  function MultiAwardTutorialModal(options) {
    _classCallCheck(this, MultiAwardTutorialModal);

    this.options = {
      awardSingleEntryCallback: null,
      awardMultipleEntriesCallback: null,
      cancelCallback: null,
      contest: null,
      entry: null,
      containerId: 'contest_popup-container',
      modalId: 'multi-award-tutorial'
    };

    this.setOptions(options);

    this.canAwardMultipleEntries = this.options.contest.totalEntries > 1 && this.options.contest.isContestHolder;

    this.container = document.getElementById(this.options.containerId);
    this.modal = jq(template(tutorialModalTemplate)({
      T_: translate,
      uiIcon: uiIcon,
      entry: this.options.entry
    }));
    this.modalDom = this.modal.get(0);
    this.modalDom.setAttribute('id', this.options.modalId);
    this.bindEvents();
  }

  _createClass(MultiAwardTutorialModal, [{
    key: 'setOptions',
    value: function setOptions(options) {
      this.options = Object.assign(this.options, options || {});
    }
  }, {
    key: 'trackUserActions',
    value: function trackUserActions(values) {
      var trackingValues = Object.assign({
        eventName: 'user_action',
        section: 'ContestAwardModal'
      }, values || {});

      qtsp.push(trackingValues);
    }
  }, {
    key: 'awardMultipleEntries',
    value: function awardMultipleEntries() {
      if (!this.canAwardMultipleEntries) {
        return;
      }

      this.modal.find('button').prop('disabled', true);

      if (typeof this.options.awardMultipleEntriesCallback === 'function') {
        this.options.awardMultipleEntriesCallback();
      }

      this.modal.modal('hide');
      this.trackUserActions({ subsection: 'MultiAward', name: 'Award' });
    }
  }, {
    key: 'awardSingleEntry',
    value: function awardSingleEntry() {
      if (this.options.contest.isFreemium) {
        this.hide();
      }

      this.modal.find('button').prop('disabled', true);

      if (typeof this.options.awardSingleEntryCallback === 'function') {
        this.options.awardSingleEntryCallback();
      }

      Tracking.trackCustomEvent('Award Contest Entry', 'Contest Award Modal');
      this.trackUserActions({ subsection: 'SingleAward', name: 'Award' });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (typeof this.options.cancelCallback === 'function') {
        this.options.cancelCallback();
      }

      this.trackUserActions({ subsection: 'SingleAward', name: 'Cancel' });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.modalDom.querySelector(selectors.awardSingleEntry).addEventListener('click', this.awardSingleEntry.bind(this));
      if (this.canAwardMultipleEntries && this.options.awardMultipleEntriesCallback) {
        this.modalDom.querySelector(selectors.awardMultipleEntries).addEventListener('click', this.awardMultipleEntries.bind(this));
      } else {
        this.modalDom.querySelector('.MultiAwardModal-textBreak').classList.add('is-hidden');
        this.modalDom.querySelector(selectors.awardMultipleEntries).classList.add('is-hidden');
      }
      this.modalDom.querySelector(selectors.closeButton).addEventListener('click', this.cancel.bind(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var existingModal = this.container.querySelector('#' + this.options.modalId);

      if (existingModal) {
        jq(existingModal).replaceWith(this.modalDom);
      } else {
        this.container.appendChild(this.modalDom);
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.modal.modal('show');
      qtsp.push({
        eventName: 'abtest',
        test: 'ContestAwardModal',
        variation: 'double-panel',
        reference_type: 'contest_id',
        reference_value: this.options.contest.id
      });

      return true;
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.modal.modal('hide');
    }
  }]);

  return MultiAwardTutorialModal;
}();

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry$$1 = entries[index];
    this.set(entry$$1[0], entry$$1[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used to resolve the decompiled source of functions. */
var funcToString = Function.prototype.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var objectProto$12 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$12.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$13 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$13.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$14 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$14.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$7.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry$$1 = entries[index];
    this.set(entry$$1[0], entry$$1[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry$$1 = entries[index];
    this.set(entry$$1[0], entry$$1[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || typeof key == 'number' && value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

/** Used for built-in method references. */
var objectProto$15 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$6 = objectProto$15.toString;

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString$6.call(value);
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used for built-in method references. */
var objectProto$16 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$7 = objectProto$16.toString;

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = objectToString$7.call(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : undefined;

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

var getTag$1 = getTag;

/** Used for built-in method references. */
var objectProto$17 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$17.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$8.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor());
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor());
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag:case float64Tag:
    case int8Tag:case int16Tag:case int32Tag:
    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag$1:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag$1:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$2 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$2] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$2] = cloneableTags[numberTag$2] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$2] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$1] = cloneableTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag$1 || tag == genTag$1;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/** `Object#toString` result references. */
var objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$18 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$18.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$8 = objectProto$18.toString;

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object,
 *  else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || objectToString$8.call(value) != objectTag$2 || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    mapTag$3 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$3 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$2] = typedArrayTags[mapTag$3] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$3] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;

/** Used for built-in method references. */
var objectProto$19 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$9 = objectProto$19.toString;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString$9.call(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || srcIndex && isFunction(objValue)) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      } else {
        newValue = objValue;
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = keysIn(source);
  }
  arrayEach(props || source, function (srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack());
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(object[key], srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var contestPaymentModalTemplate = "<div class=\"responsive-modal\" id=\"expanded-payment-modal\">\n  <div class=\"modal ModalPayment\" aria-label=\"<%- T_('Chiudi') %>\" data-backdrop=\"true\">\n    <div class=\"modal-header ModalPayment-header\">\n      <button id=\"paymentModalCloseButton\" type=\"button\" class=\"payment-modal-close close\" data-dismiss=\"modal\" aria-label=\"<%- T_('Chiudi') %>\">\n        <span class=\"Icon Icon--small\">\n          <%=  uiIcon('ui-close-alt')  %>\n        </span>\n      </button>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"ModalPayment-body\">\n        <figure class=\"ModalPayment-figure\">\n          <img class=\"ModalPayment-image\" src=\"<%=  cdn_url('/static/img/secure-payment.png')  %>\" alt=\"<%- T_('Pagamento sicuro') %>\" />\n        </figure>\n        <div class=\"ModalPayment-heading\"><%-  heading  %></div>\n        <%  if (subHeading) {  %>\n          <div class=\"ModalPayment-subHeading\"><%-  subHeading  %></div>\n        <%  }  %>\n        <%  if (showCharges) {  %>\n          <%  for (i = 0; i < chargeDetails.length; i++) {  %>\n            <%  if (parseFloat(chargeDetails[i].amount) > 0) {  %>\n              <div class=\"ModalPayment-paymentDetails\">\n                <div class=\"ModalPayment-label\">\n                  <%=  chargeDetails[i].label  %>\n                </div>\n                <div class=\"ModalPayment-price\">\n                  <span class=\"ModalPayment-totalCost-price\">\n                    <%  if (chargeDetails[i].paid) {  %>\n                      <span class=\"ModalPayment-totalCost-price-paid\">\n                        <%- T_('PAGATO') %>\n                      </span>\n                    <%  } else {  %>\n                      <%-  currency.sign  %><%-  chargeDetails[i].amount.toFixed(2)  %>\n                    <%  }  %>\n                  </span>\n                </div>\n              </div>\n            <%  }  %>\n          <%  }  %>\n          <div class=\"ModalPayment-totalCost\">\n            <span class=\"ModalPayment-totalCost-label\"><%- T_('Totale:') %></span>\n            <span class=\"ModalPayment-totalCost-price\">\n              <%-  currency.sign  %><%-  chargeTotal.toFixed(2)  %> <%-  currency.code  %>\n            </span>\n            <%  if (includesGST) {  %>\n              <div class=\"ModalPayment-totalCost-detail\"><%- T_('GST inclusa') %></div>\n            <%  } else if (includesVAT) {  %>\n              <div class=\"ModalPayment-totalCost-detail\"><%- T_('IVA inclusa') %></div>\n            <%  }  %>\n          </div>\n        <%  }  %>\n        <%  if (text) {  %>\n            <p class=\"ModalPayment-descriptionText\"><%=  text  %></p>\n        <%  }  %>\n      </div>\n      <div class=\"ModalPayment-footer\n        <%  if (!footerText) {  %>\n          ModalPayment-footer-noText\n        <%  }  %>\n      \">\n        <%  if (footerText) {  %>\n            <p><%-  footerText  %></p>\n        <%  }  %>\n        <button id=\"paymentModalConfirmButton\" class=\"btn btn-large btn-success ModalPayment-footer-btn\"><%-  buttonLabel  %></button>\n      </div>\n    </div>\n  </div>\n</div>\n";

var _templateObject$4 = _taggedTemplateLiteral(['Conferma il pagamento'], ['Conferma il pagamento']),
    _templateObject2$1 = _taggedTemplateLiteral(['Dettagli del prodotto'], ['Dettagli del prodotto']),
    _templateObject3$1 = _taggedTemplateLiteral(['L\'importo verr\xE0 addebitato sui tuoi saldi disponibili e, se necessario, proveremo a elaborare il pagamento a partire dai tuoi metodi di pagamento verificati.'], ['L\'importo verr\xE0 addebitato sui tuoi saldi disponibili e, se necessario, proveremo a elaborare il pagamento a partire dai tuoi metodi di pagamento verificati.']),
    _templateObject4$1 = _taggedTemplateLiteral(['Il tuo concorso \xE8 pronto ad entrare in scena!'], ['Il tuo concorso \xE8 pronto ad entrare in scena!']),
    _templateObject5$1 = _taggedTemplateLiteral(['Per iniziare a ricevere proposte dai nostri talentuosi freelance, effettua un pagamento di <span class="ModalPayment-descriptionText-totalCost"> ', '', ' ', ' </span> per ultimare la pubblicazione del tuo concorso.'], ['Per iniziare a ricevere proposte dai nostri talentuosi freelance, effettua un pagamento di <span class="ModalPayment-descriptionText-totalCost"> ', '', ' ', ' </span> per ultimare la pubblicazione del tuo concorso.']),
    _templateObject6$1 = _taggedTemplateLiteral(['Effettua il pagamento'], ['Effettua il pagamento']),
    _templateObject7$1 = _taggedTemplateLiteral(['\xC8 necessario fornire l\'importo totale'], ['\xC8 necessario fornire l\'importo totale']),
    _templateObject8$1 = _taggedTemplateLiteral(['Importo totale non valido'], ['Importo totale non valido']),
    _templateObject9$1 = _taggedTemplateLiteral(['Errore del server. Riprova per piacere.'], ['Errore del server. Riprova per piacere.']);

var contestApi$1 = new ContestApi();
var compiledPaymentModalTemplate = template(contestPaymentModalTemplate);
var lt$1 = new LocalTracking();

var FixedAmountPaymentModal = function () {
  function FixedAmountPaymentModal(options) {
    _classCallCheck(this, FixedAmountPaymentModal);

    this.modal = null;

    var total = options.modalData.chargeTotal.toFixed(2);
    var currencySign = options.modalData.currency.sign;

    this.options = merge({
      modalData: {
        chargeTotal: null,
        chargeDetails: [],
        currency: {
          id: null,
          sign: null,
          code: null },

        includesGST: false,
        includesVAT: false,
        spiels: {
          hasEnoughBalanceOrPaymentMethod: {
            heading: translate(_templateObject$4),
            subHeading: translate(_templateObject2$1),
            text: null,
            footerText: translate(_templateObject3$1),

            buttonLabel: translate(_templateObject$4),
            showCharges: true },

          noBalanceOrPaymentMethod: {
            heading: translate(_templateObject4$1),
            subHeading: null,
            text: translate(_templateObject5$1, currencySign, total, options.modalData.currency.code),

            footerText: null,
            buttonLabel: translate(_templateObject6$1),
            showCharges: false } },

        heading: null,
        subHeading: null,
        text: null,
        buttonLabel: null,
        showCharges: true,
        contestId: null },

      callbacks: {
        confirm: jq.noop,
        close: jq.noop,
        onQuickViewShow: jq.noop },

      trackingData: {
        section: 'ContestPostModal',
        subsection: 'PostContest' } }, options || {});

    this.initialize();
  }

  _createClass(FixedAmountPaymentModal, [{
    key: 'removeExistingModal',
    value: function removeExistingModal() {
      jq('#expanded-payment-modal').modal('hide').remove();
    }
  }, {
    key: 'bindEventHandlers',
    value: function bindEventHandlers(data) {
      var _this = this;

      this.modal.on('click', '#paymentModalConfirmButton', function () {
        _this.modal.modal('hide');

        if (data.value === 'MakePayment') {
          data.name = 'Deposit';
        } else if (data.section === 'ContestPostModal') {
          data.name = 'Post';
        } else if (data.subsection === 'UpgradeContest' || data.subsection === 'EditContest') {
          data.name = 'Upgrade';
        } else {
          data.name = 'Award';
        }

        _this.sendTrackingData(data);
        _this.options.callbacks.confirm();
      });

      this.modal.on('click', '#paymentModalCloseButton', function () {
        data.name = 'Cancel';
        _this.sendTrackingData(data);
        _this.options.callbacks.close();
      });

      this.modal.on('shown.bs.modal', function () {
        data.name = 'ShowModal';
        _this.sendTrackingData(data);
      });
    }
  }, {
    key: 'sendTrackingData',
    value: function sendTrackingData(data) {
      var defaultData = {
        label: 'PaymentConfirmationModal',
        reference: 'contest_id',
        reference_id: this.options.modalData.contestId };

      var trackingData = Object.assign({}, defaultData, data);

      trackingData.subsection = 'MultiAwardCVP';

      lt$1.push(['user_action', trackingData]);
    }
  }, {
    key: 'initialize',
    value: function initialize() {
      var _this2 = this;

      var hasEnoughBalanceOrPaymentMethod = false;

      if (!this.options.modalData.chargeTotal) {
        showErrorModal(translate(_templateObject7$1));
        return;
      }

      var totalFloat = parseFloat(this.options.modalData.chargeTotal);
      if (Number.isNaN(totalFloat)) {
        showErrorModal(translate(_templateObject8$1));
        return;
      }

      if (totalFloat <= 0) {
        this.options.callbacks.confirm();
      }

      contestApi$1.getUserPaymentMethodInfo({
        currency: this.options.modalData.currency.id }).then(function (data) {
        if (data.firstAvailablePaymentMethod || parseInt(data.totalBalance.currency.id || 0, 10) === parseInt(_this2.options.modalData.currency.id || 0, 10) && parseFloat(data.totalBalance.amount || 0) >= parseFloat(_this2.options.modalData.chargeTotal || 0)) {
          hasEnoughBalanceOrPaymentMethod = true;
        }

        _this2.removeExistingModal();

        if (hasEnoughBalanceOrPaymentMethod) {
          merge(_this2.options.modalData, _this2.options.modalData.spiels.hasEnoughBalanceOrPaymentMethod || {});
        } else {
          merge(_this2.options.modalData, _this2.options.modalData.spiels.noBalanceOrPaymentMethod || {});
        }

        _this2.options.modalData.T_ = translate;
        _this2.options.modalData.uiIcon = uiIcon;
        _this2.options.modalData.cdn_url = cdn_url;

        _this2.modal = jq(compiledPaymentModalTemplate(_this2.options.modalData)).appendTo('.pinky-template:first');

        _this2.options.trackingData.value = hasEnoughBalanceOrPaymentMethod ? 'ConfirmPayment' : 'MakePayment';

        _this2.bindEventHandlers(_this2.options.trackingData);

        _this2.modal.modal({
          backdrop: 'static',
          keyboard: true });

        _this2.options.callbacks.onQuickViewShow(_this2.modal);
      }).catch(function () {
        showErrorModal(translate(_templateObject9$1));
      });
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.modal) {
        this.modal.modal('show');
      }
    }
  }]);

  return FixedAmountPaymentModal;
}();

var loggedOutCommentTemplate = "<li class=\"commentBoard-comment\" data-selector=\"comment-main\" data-message-id=\"<%-  msg_id  %>\">\n  <img src=\"<%-  profile_logo_url  %>\" class=\"commentBoard-avatar\" alt=\"<%-  username  %>\" />\n  <header class=\"commentBoard-headerItems\">\n    <%  if (!is_holder_message) {  %>\n      <h6 class=\"commentBoard-commentHeader\">\n        <a href=\"<%-  user_url  %>\" class=\"username\"><%-  username  %></a>\n      </h6>\n    <%  } else {  %>\n      <span class=\"commentBoard-userType\"><%= T_('Titolare del concorso') %></span>\n    <%  }  %>\n    <ul class=\"commentBoard-commentDetails\" data-selector=\"comment-details\"></ul>\n  </header>\n  <p><%=  formattedComment  %></p>\n  <ul class=\"commentBoard-commentDetails commentBoard-mobile\" data-selector=\"comment-details\"></ul>\n  <%  if(!parentId) {  %>\n    <%  if (totalHiddenMessages > 0) {  %>\n      <div class=\"commentBoard-viewReplies view-more-comment\" data-parent-id=\"<%-  msg_id  %>\">\n        <a href=\"javascript:void(0);\" class=\"small\" data-selector=\"view-more-comment-link\">\n          <%  if (totalHiddenMessages == 1) {  %>\n            <%= T_(\"Visualizza 1 altro messaggio\") %>\n          <%  } else {  %>\n            <%= T_(\"Visualizza <[- totalHiddenMessages]> messaggi in più\", { totalHiddenMessages: totalHiddenMessages }) %>\n          <%  }  %>\n        </a>\n        <img src=\"<%=  cdn_url('/img/ajax-loader.gif')  %>\" class=\"view-more-comment-loader hide\"\n          data-selector=\"view-more-comment-loader\" alt=\"<%= T_('In elaborazione...') %>\"/>\n      </div>\n    <%  }  %>\n    <ol class=\"commentBoard-subList contest-replies\" data-selector=\"comment-reply-list\"></ol>\n  <%  }  %>\n</li>\n";

var prevThumbnailButtonTemplate = "<a class=\"PageContestFullView-entryImages-nav-link\">\n    <span class=\"Icon\"><%=  uiIcon('ui-arrow-left-alt')  %></span>\n</a>\n";

var nextThumbnailButtonTemplate = "<a class=\"PageContestFullView-entryImages-nav-link\">\n    <span class=\"Icon\"><%=  uiIcon('ui-arrow-right-alt')  %></span>\n</a>\n";

var imageEntryTemplate = "<figure data-displayer=\"imageFileDisplayer\" class=\"PageContestFullView-entryImages-figure\">\n  <picture>\n      <source data-hook=\"imageEntryFileMobile\" media=\"(max-width: 480px)\" srcset=\"<%-  entryImageSrcMobile  %>\"/>\n      <img\n          data-hook=\"imageEntryFile\"\n          class=\"PageContestFullView-entryImages-image\"\n          fetchpriority=\"high\"\n          src=\"<%-  entryImageSrc  %>\"\n          alt=\"<%- T_('Proposta #<[- entryNumber ]> per il concorso <[- contestName ]>', { 'entryNumber': entryNumber, 'contestName': contestName }) %>\">\n  </picture>\n</figure>\n";

var imageEntryThumbnailTemplate = "<div class=\"PageContestFullView-carousel-item\">\n  <figure class=\"PageContestFullView-carousel-figure\">\n    <img class=\"PageContestFullView-carousel-image\"\n      src=\"<%-  thumbImage  %>\"\n      data-file-index=\"<%-  thumbFileIndex  %>\"\n      alt=\"<%- T_('Anteprima proposta #<[- entryNumber ]> per il concorso <[- contestName ]>', { 'entryNumber': entryNumber, 'contestName': contestName }) %>\">\n  </figure>\n</div>\n";

var videoEntryTemplate = "<div data-displayer=\"videoFileDisplayer\" class=\"PageContestFullView-entryVideo-figure\">\n  <video id=\"player\" class=\"video-js vjs-default-skin vjs-big-play-centered\n  \tPageContestFullView-entryVideo-container\" controls\n  \tdata-setup='{\"controls\": true}'\n    preload=\"auto\" width=\"768\" height=\"432\" poster=\"<%-  videoPosterSrc  %>\">\n      <source src=\"<%-  videoMp4Src  %>\" type='video/mp4'>\n      <source src=\"<%-  videoWebMSrc  %>\" type='video/webm'>\n  </video>\n  <div class=\"video-buttons-container\"></div>\n</div>\n";

var textEntryTemplate = "<figure data-displayer=\"textFileDisplayer\" class=\"PageContestFullView-entryText-figure\">\n    <iframe data-hook=\"textFileIFrame\" class=\"fl-modal-iframe\"\n        src=\"<%-  iframeSrc  %>\"\n        style=\"width: 100%; height: 600px;\">\n    </iframe>\n</figure>\n";

var _templateObject$5 = _taggedTemplateLiteral(['/contest/text_viewer.php?file=\n  /contest/getEntryFile.php?file_path='], ['/contest/text_viewer.php?file=\n  /contest/getEntryFile.php?file_path=']),
    _templateObject2$2 = _taggedTemplateLiteral(['width=', ', height=', ',\n      left=', ', top=', ''], ['width=', ', height=', ',\n      left=', ', top=', '']),
    _templateObject3$2 = _taggedTemplateLiteral(['Impossibile selezionare la proposta vincente. Aggiorna la pagina e riprova per piacere.'], ['Impossibile selezionare la proposta vincente. Aggiorna la pagina e riprova per piacere.']),
    _templateObject4$2 = _taggedTemplateLiteral(['Errore del server. Impossibile selezionare la proposta vincente. Aggiorna la pagina e riprova per piacere.'], ['Errore del server. Impossibile selezionare la proposta vincente. Aggiorna la pagina e riprova per piacere.']),
    _templateObject5$2 = _taggedTemplateLiteral(['Proposta #', ''], ['Proposta #', '']),
    _templateObject6$2 = _taggedTemplateLiteral(['Assegna e conferma il pagamento'], ['Assegna e conferma il pagamento']),
    _templateObject7$2 = _taggedTemplateLiteral(['Conferma il pagamento'], ['Conferma il pagamento']),
    _templateObject8$2 = _taggedTemplateLiteral(['Assegna e completa il pagamento'], ['Assegna e completa il pagamento']),
    _templateObject9$2 = _taggedTemplateLiteral(['Completa il pagamento'], ['Completa il pagamento']),
    _templateObject10$1 = _taggedTemplateLiteral(['Per completare l\'assegnazione, verrai reindirizzato alla pagina dei depositi dove potrai effettuare un pagamento di <span class="ModalPayment-descriptionText-totalCost"> ', '', ' ', '</span>.'], ['Per completare l\'assegnazione, verrai reindirizzato alla pagina dei depositi dove potrai effettuare un pagamento di <span class="ModalPayment-descriptionText-totalCost"> ', '', ' ', '</span>.']),
    _templateObject11$1 = _taggedTemplateLiteral(['Impossibile eliminare la proposta, riprova per piacere.'], ['Impossibile eliminare la proposta, riprova per piacere.']),
    _templateObject12$1 = _taggedTemplateLiteral(['Impossibile riconsiderare la proposta, riprova per piacere.'], ['Impossibile riconsiderare la proposta, riprova per piacere.']),
    _templateObject13$1 = _taggedTemplateLiteral(['Errore del server. Impossibile mettere mi piace alla proposta. Aggiorna la pagina e riprova per piacere.'], ['Errore del server. Impossibile mettere mi piace alla proposta. Aggiorna la pagina e riprova per piacere.']),
    _templateObject14$1 = _taggedTemplateLiteral(['http://twitter.com/intent/tweet?text=', '\n      ', ''], ['http://twitter.com/intent/tweet?text=', '\n      ', '']),
    _templateObject15$1 = _taggedTemplateLiteral(['http://www.linkedin.com/shareArticle?mini=true&url=\n      ', '&title=', '&summary=', ''], ['http://www.linkedin.com/shareArticle?mini=true&url=\n      ', '&title=', '&summary=', '']),
    _templateObject16$1 = _taggedTemplateLiteral(['Compra per ', ''], ['Compra per ', '']),
    _templateObject17$1 = _taggedTemplateLiteral(['Formato proposta sconosciuto. Aggiorna la pagina e riprova per piacere.'], ['Formato proposta sconosciuto. Aggiorna la pagina e riprova per piacere.']);

var MESSAGE_BOARD_PRIVACY = 'public';
var LIKED_CLASS = 'contest_entry-liked';
var NOT_LIKED_CLASS = 'contest_entry-not-liked';

var ENTRY_CONTAINER_CLASS = 'PageContestFullView-entryImages-container';
var VIDEO_ENTRY_CONTAINER_CLASS = 'PageContestFullView-entryVideo';
var TEXT_ENTRY_CONTAINER_CLASS = 'PageContestFullView-entryText';

var entryApi$1 = new EntryApi();
var sellEntry = new SellEntry();
var lt$2 = new LocalTracking();
var VIEWER_SOURCE = oneLineTrim(_templateObject$5);

var HIDDEN_ELEMENT_CLASS = 'is-hidden';
var LOADING_PLACEHOLDER_CLASS = 'loading-placeholder';

var FILE_FORMAT_IMAGE = 'image';
var FILE_FORMAT_VIDEO = 'video';
var FILE_FORMAT_TEXT = 'text';

var FILE_DISPLAYER_ATTR = 'data-displayer';
var IMAGE_DISPLAYER_NAME = 'imageFileDisplayer';
var VIDEO_DISPLAYER_NAME = 'videoFileDisplayer';
var TEXT_DISPLAYER_NAME = 'textFileDisplayer';

var compiledImageEntryTemplate = template(imageEntryTemplate);
var compiledEntryThumbnailTemplate = template(imageEntryThumbnailTemplate);
var compiledVideoEntryTemplate = template(videoEntryTemplate);
var compiledTextEntryTemplate = template(textEntryTemplate);

var entryTitleEl = document.getElementById('entry-title');
var entryDescriptionEl = document.getElementById('entry-description');
var entryRatingEl = document.getElementById('entry-rating');
var entryLikesEl = document.getElementById('entry-likes');
var entryLikesIcon = document.getElementById('entry-likes-icon');
var nextEntryEl = document.getElementById('next-entry');
var prevEntryEl = document.getElementById('prev-entry');
var viewEntriesLinkEl = document.getElementById('view-entries-link');
var reportButtonEl = document.getElementById('report-entry');
var fbShareButton = document.getElementById('share-fb-sidebar');
var twShareButton = document.getElementById('share-tw-sidebar');
var inShareButton = document.getElementById('share-in-sidebar');
var ratingContainerEl = document.getElementById('rating-container');
var entryActionsEl = document.getElementById('entry-actions');
var rejectedStateEl = document.getElementById('rejected-state');
var winnerTextEl = document.getElementById('winner-text');
var runnerUpTextEl = document.getElementById('runner-up-text');
var rejectActionEl = document.getElementById('reject-action');
var awardActionEl = document.getElementById('award-action');
var buyActionEl = document.getElementById('buy-action');
var reportEntryContainer = document.getElementById('report-entry-container');
var preloader = document.getElementById('preloader');
var reconsiderActionEl = document.getElementById('reconsider-action');
var awardLinkEl = document.getElementById('award-link');
var buyLinkEl = document.getElementById('buy-link');
var carouselThumbs = document.getElementById('thumbnail-carousel');
var entryContainer = document.querySelector('[data-hook="entry-container"]');
var loaderEl = document.getElementById('fullview-loader');
var entryNumberEl = document.getElementById('navigation-entry-number');
var repostContestBtnGroup = document.querySelectorAll('[data-selector="repost"]');

var postContestBtnGroup = document.querySelectorAll('[data-selector="post"]');
var loadingSpinner = document.querySelector('[data-hook="loading-spinner"]');

var selectors$1 = {
  imageEntryFile: '[data-hook="imageEntryFile"]',
  imageEntryFileMobile: '[data-hook="imageEntryFileMobile"]' };

var modalWidth = 600;
var modalHeight = 400;
var leftPosition = window.screen.width / 2 - modalWidth / 2;
var topPosition = 200;
var leftArrowKey = 37;
var rightArrowKey = 39;

var currentEntry = entry;
var nextEntry = entry.nextEntry;
var prevEntry = entry.prevEntry;
var isCurrentEntryLiked = isEntryLiked;
var isLikeRestricted = false;
var allowNavigation = true;
var reportEntryModal = null;
var multiAwardModal = null;

var messageBoard = initMessageBoard();

init$1();

nextEntryEl.addEventListener('click', function (event) {
  event.preventDefault();
  if (nextEntry.hasUrl) {
    navigate(nextEntry.id);
  }
});

prevEntryEl.addEventListener('click', function (event) {
  event.preventDefault();
  if (entry.prevEntry.hasUrl) {
    navigate(prevEntry.id);
  }
});

entryLikesIcon.addEventListener('click', function () {
  if (!isLoggedIn) {
    window.location = loginUrl;
  } else {
    toggleLike();
  }
});

if (isLoggedIn && contest.isContestHolder) {
  initRating(entry.rating);

  document.getElementById('interactive-rating').addEventListener('click', function (event) {
    if (event.target.tagName.toUpperCase() === 'A') {
      submitEntryRating(parseInt(event.target.text, 10));
    }
  });
}

reportButtonEl.addEventListener('click', function () {
  qtsp.push({
    eventName: 'user_action',
    section: 'EntryFullViewPage',
    name: 'ReportViolation',
    reference: 'entry_id',
    reference_id: currentEntry.id,
    label: 'contest_id',
    value: contest.id });

  if (!reportEntryModal) {
    reportEntryModal = new InfractionsModal(infractionTypes, currentEntry.id, {
      defaultInfractionCategory: 'contestEntry',
      context: 'contest_entry' });
  }

  reportEntryModal.modal.show();
});

Array.from(postContestBtnGroup).forEach(function (element) {
  element.addEventListener('click', function () {
    lt$2.push(['user_action', {
      name: 'GoToPostContest',
      value: 'Post',
      section: 'EntryFullViewPage' }]);
  });
});

Array.from(repostContestBtnGroup).forEach(function (element) {
  element.addEventListener('click', function () {
    lt$2.push(['user_action', {
      name: 'GoToPostContest',
      value: 'Repost',
      section: 'EntryFullViewPage' }]);
  });
});

fbShareButton.addEventListener('click', function (event) {
  return onShareClick(event);
});
twShareButton.addEventListener('click', function (event) {
  return onShareClick(event);
});
inShareButton.addEventListener('click', function (event) {
  return onShareClick(event);
});

rejectActionEl.addEventListener('click', function () {
  rejectCurrentEntry();
});

reconsiderActionEl.addEventListener('click', function () {
  reconsiderCurrentEntry();
});

awardLinkEl.addEventListener('click', function () {
  qtsp.push({
    eventName: 'user_action',
    name: 'AwardContest',
    reference: 'entry_id',
    reference_id: currentEntry.id,
    label: 'contest_id',
    value: contest.id,
    section: 'EntryFullViewPage' });

  awardCurrentEntry();
});

buyLinkEl.addEventListener('click', function () {
  buyCurrentEntry();
});

initializeSlider();

bindThumbnailEvents();

if (entry.files[0].isText) {
  displayTextFile(entry.files[0]);
}

document.onkeydown = function (e) {
  if (allowNavigation) {
    switch (e.keyCode) {
      case leftArrowKey:
        navigate(prevEntry.id);
        break;
      case rightArrowKey:
        navigate(nextEntry.id);
        break;
      default:
        break;}
  }
};

function onShareClick(event) {
  event.preventDefault();
  var href = event.currentTarget.getAttribute('href');
  var windowShare = window.open(href, 'Freelancer.com', oneLine(_templateObject2$2, modalWidth, modalHeight, leftPosition, topPosition));

  windowShare.moveTo(leftPosition, topPosition);
}

function addHideClass(element) {
  if (!element.classList.contains('hide')) {
    element.classList.add('hide');
  }
}

function removeHideClass(element) {
  if (element.classList.contains('hide')) {
    element.classList.remove('hide');
  }
}

function awardSingleEntryCallback() {
  entryApi$1.award({
    entry_id: currentEntry.id }).then(function (response) {
    if (response && response.result === 'redirect') {
      window.location = response.redirect;
    } else {
      showErrorModal(translate(_templateObject3$2));

      multiAwardModal.hide();
    }
  }).catch(function () {
    showErrorModal(translate(_templateObject4$2));

    multiAwardModal.hide();
  });
}

function awardCurrentEntry() {
  if (contest.isFreemium) {
    new FixedAmountPaymentModal({
      modalData: {
        chargeTotal: contest.prize,
        chargeDetails: [{
          label: translate(_templateObject5$2, currentEntry.number),
          amount: contest.prize }],

        currency: contest.currency,
        includesGST: user.taxName === 'GST',
        includesVAT: user.taxName === 'VAT',
        contestId: contest.id,
        spiels: {
          hasEnoughBalanceOrPaymentMethod: {
            heading: translate(_templateObject6$2),
            buttonLabel: translate(_templateObject7$2) },

          noBalanceOrPaymentMethod: {
            heading: translate(_templateObject8$2),
            buttonLabel: translate(_templateObject9$2),
            text: translate(_templateObject10$1, contest.currency.sign, contest.prize, contest.currency.code) } } },

      callbacks: {
        confirm: awardSingleEntryCallback.bind(this) },

      trackingData: {
        section: 'ContestAwardModal',
        subsection: 'SingleAward' } });
  } else {
    multiAwardModal = new MultiAwardTutorialModal({
      awardSingleEntryCallback: awardSingleEntryCallback.bind(this),
      contest: contest,
      entry: currentEntry,
      loggedInUser: loggedInUser });

    multiAwardModal.show();
  }
}

function buyCurrentEntry() {
  sellEntry.openBuyEntryModal({
    entryId: currentEntry.id,
    username: currentEntry.username,
    publicUserName: currentEntry.publicUserName,
    userid: currentEntry.userId,
    thumb: currentEntry.thumb420,
    number: currentEntry.number,
    sellPrice: parseFloat(currentEntry.sellPrice) || parseFloat(contest.prize),
    currency: contest.currency });
}

function rejectCurrentEntry() {
  var data = {
    entry_id: currentEntry.id };

  addHideClass(entryActionsEl);
  removeHideClass(preloader);

  entryApi$1.reject(data).then(function (response) {
    if (response.result !== 'success') {
      removeHideClass(entryActionsEl);
      showErrorModal(translate(_templateObject11$1));
    } else {
      removeHideClass(rejectedStateEl);
    }
  }).catch(function () {
    removeHideClass(entryActionsEl);
    showErrorModal(translate('Errore del server. Impossibile eliminare la proposta.'));
  }).then(function () {
    addHideClass(preloader);
  });
}

function reconsiderCurrentEntry() {
  var data = {
    entry_id: currentEntry.id };

  addHideClass(rejectedStateEl);
  removeHideClass(preloader);

  entryApi$1.reconsider(data).then(function (response) {
    if (response.result !== 'success') {
      removeHideClass(rejectedStateEl);
      showErrorModal(translate(_templateObject12$1));
    } else {
      removeHideClass(entryActionsEl);
    }
  }).catch(function () {
    removeHideClass(rejectedStateEl);
    showErrorModal(translate('Errore del server. Impossibile riconsiderare la proposta.'));
  }).then(function () {
    addHideClass(preloader);
  });
}

function initRating(entryRating) {
  var rating = parseInt(entryRating, 10) || 0;
  var ratingButtons = jq('#interactive-rating').find('[data-rating-input]');
  ratingButtons.rating();
  ratingButtons.rating('select', rating.toString());
}

function initMessageBoard() {
  var options = {};

  if (isLoggedIn) {
    options = {
      contest: contest,
      user: user,
      entry: {
        id: currentEntry.id },

      toUser: {
        id: currentEntry.userId },

      pageName: 'EntryFullViewPage',
      infractionTypes: infractionTypes };
  } else {
    options = {
      contest: {
        id: contest.id },

      controls: {
        delete: false,
        reply: false,
        report: false },

      entry: {
        id: currentEntry.id },

      preload: {
        messagesData: messagesData,
        enabled: true,
        prerendered: true },

      messageTemplate: loggedOutCommentTemplate,
      showEmptyMessage: true };
  }

  return new MessageBoard(options, MESSAGE_BOARD_PRIVACY);
}

function submitEntryRating(rating) {
  entryApi$1.rate({
    entry_id: currentEntry.id,
    rating: rating }).then(function (response) {
    if (response.result !== 'success') {
      showErrorModal(translate('Impossibile valutare la proposta, riprova per piacere.'));
    }
  }).catch(function () {
    showErrorModal(translate('Errore del server. Impossibile valutare la proposta.'));
  });

  qtsp.push({
    eventName: 'user_action',
    section: 'ContestFullView',
    name: 'RateEntry',
    label: rating,
    value: contest.id,
    reference: 'entry_id',
    reference_id: currentEntry.id });
}

function toggleLike() {
  var totalLikes = parseInt(currentEntry.numLikes, 10);
  var data = {
    contestId: contest.id,
    entryId: currentEntry.id,
    sourceSection: 'EntryFullViewPage' };

  if (isCurrentEntryLiked) {
    currentEntry.numLikes = totalLikes - 1;
    data.isLiked = 0;
  } else {
    currentEntry.numLikes = totalLikes + 1;
    data.isLiked = 1;
  }

  data.numLikes = currentEntry.numLikes.toString();

  entryApi$1.toggleLike(data).then(function (response) {
    if (response && response.status === 'success') {
      isCurrentEntryLiked = !isCurrentEntryLiked;
      setLikes();
    } else if (response && response.status === 'restricted') {
      // User is not allowed to like this entry. Do nothing.
      return true;
    } else {
      throw new Error();
    }
  }).catch(function () {
    if (isCurrentEntryLiked) {
      currentEntry.numLikes = totalLikes + 1;
    } else {
      currentEntry.numLikes = totalLikes - 1;
    }

    showErrorModal(translate(_templateObject13$1));
  });

  qtsp.push({
    eventName: 'user_action',
    section: 'EntryFullViewPage',
    name: 'LikeEntry',
    label: data.isLiked ? 'Like' : 'Unlike',
    value: contest.id,
    reference: 'entry_id',
    reference_id: currentEntry.id });
}

function updateEntryDetails(showEntry) {
  if (showEntry) {
    viewEntriesLinkEl.setAttribute('href', currentEntry.user.seoUrl);
    viewEntriesLinkEl.textContent = currentEntry.publicUserName;

    entryTitleEl.textContent = currentEntry.title;
    entryDescriptionEl.textContent = currentEntry.description;
  } else {
    viewEntriesLinkEl.setAttribute('href', '');
    viewEntriesLinkEl.textContent = '';

    entryTitleEl.textContent = '';
    entryDescriptionEl.textContent = '';
  }
}

function updateMessageBoard() {
  messageBoard.clear();
  messageBoard.setEntryId(currentEntry.id);
  messageBoard.disablePreload();
  messageBoard.populateMessageBoard();
}

function setLikes() {
  entryLikesEl.textContent = currentEntry.numLikes;

  if (isLikeRestricted) {
    entryLikesIcon.classList.remove(NOT_LIKED_CLASS);
    entryLikesIcon.classList.remove(LIKED_CLASS);
    entryLikesIcon.classList.add('Tooltip--bottom');
    entryLikesIcon.classList.add('Endorse-itemLink-like--restricted');
    entryLikesIcon.setAttribute('data-tooltip', translate('Non ti è consentito mettere mi piace a questa proposta'));
  } else {
    entryLikesIcon.classList.remove('Tooltip--bottom');
    entryLikesIcon.classList.remove('Endorse-itemLink-like--restricted');
    entryLikesIcon.removeAttribute('data-tooltip');
    if (isCurrentEntryLiked) {
      entryLikesIcon.classList.add(LIKED_CLASS);
      entryLikesIcon.classList.remove(NOT_LIKED_CLASS);
    } else {
      entryLikesIcon.classList.remove(LIKED_CLASS);
      entryLikesIcon.classList.add(NOT_LIKED_CLASS);
    }
  }
}

function updateShareLinks(shareDetails) {
  var link = encodeURIComponent('' + siteUrl + shareDetails.url);
  var title = encodeURIComponent(shareDetails.title);
  var description = encodeURIComponent(shareDetails.description);

  fbShareButton.setAttribute('href', 'http://www.facebook.com/share.php?u=' + link);

  twShareButton.setAttribute('href', oneLine(_templateObject14$1, title, link));

  inShareButton.setAttribute('href', oneLineTrim(_templateObject15$1, link, title, description));
}

function updateEntryState(vars) {
  if (vars.entry.is_eliminated) {
    addHideClass(ratingContainerEl);
    addHideClass(entryActionsEl);
    addHideClass(reportEntryContainer);

    if (vars.entry.is_eliminated) {
      removeHideClass(rejectedStateEl);
    } else {
      addHideClass(rejectedStateEl);
    }
  } else {
    removeHideClass(ratingContainerEl);
    removeHideClass(entryActionsEl);
    removeHideClass(reportEntryContainer);
    addHideClass(rejectedStateEl);

    if (vars.entry.is_winner) {
      removeHideClass(winnerTextEl);
      addHideClass(buyActionEl);
      addHideClass(awardActionEl);
    } else {
      addHideClass(winnerTextEl);
    }

    if (vars.entry.is_bought) {
      removeHideClass(runnerUpTextEl);
      addHideClass(awardActionEl);
      addHideClass(buyActionEl);
    } else {
      addHideClass(runnerUpTextEl);
    }

    if (vars.contest.is_users_contest && !vars.entry.is_winner && !vars.entry.is_bought) {
      removeHideClass(rejectActionEl);

      if (!vars.entry.hasEntryWinner) {
        removeHideClass(awardActionEl);
        addHideClass(buyActionEl);
      } else {
        addHideClass(awardActionEl);
        removeHideClass(buyActionEl);
      }
    } else {
      addHideClass(rejectActionEl);
    }
  }
}

function updateSellPrice() {
  var price = parseFloat(currentEntry.sellPrice) || parseFloat(contest.prize);
  var amount = '' + contest.currency.sign + price + ' ' + contest.currency.code;
  buyLinkEl.textContent = translate(_templateObject16$1, amount);
}

function updateArrowLinks() {
  nextEntryEl.setAttribute('href', nextEntry.url);
  prevEntryEl.setAttribute('href', prevEntry.url);
}

function displayImageFile(entryFile) {
  showLoading();

  entryContainer.className = '';
  entryContainer.classList.add(ENTRY_CONTAINER_CLASS);

  var imageFileDisplayer = entryContainer.querySelector('[' + FILE_DISPLAYER_ATTR + '="' + IMAGE_DISPLAYER_NAME + '"]');

  if (!imageFileDisplayer) {
    entryContainer.innerHTML = compiledImageEntryTemplate({
      T_: translate,
      entryImageSrc: '#',
      entryImageSrcMobile: '#',
      entryNumber: currentEntry.number,
      contestName: contest.name });

    imageFileDisplayer = entryContainer.querySelector('[' + FILE_DISPLAYER_ATTR + '="' + IMAGE_DISPLAYER_NAME + '"]');
  }

  var imageEntryFile = imageFileDisplayer.querySelector(selectors$1.imageEntryFile);

  imageEntryFile.onload = hideLoading;
  imageEntryFile.src = entryFile.thumb900;
  imageEntryFile.alt = entryFile.altText ? entryFile.altText : 'Contest Entry # ' + currentEntry.number + ' for ' + contest.name;

  var imageEntryFileMobile = imageFileDisplayer.querySelector(selectors$1.imageEntryFileMobile);

  imageEntryFileMobile.srcset = entryFile.thumb900 + '?width=420';
}

function initializeSlider() {
  jq('#thumbnail-carousel').slick({
    accessibility: false,
    speed: 500,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: false,
    appendArrows: jq('#thumbnail-carousel'),
    prevArrow: template(prevThumbnailButtonTemplate)({
      uiIcon: uiIcon }),

    nextArrow: template(nextThumbnailButtonTemplate)({
      uiIcon: uiIcon }) });
}

function updateEntryThumbnails() {
  jq('#thumbnail-carousel').slick('unslick');
  carouselThumbs.innerHTML = '';

  currentEntry.files.forEach(function (file, index) {
    carouselThumbs.innerHTML += compiledEntryThumbnailTemplate({
      T_: translate,
      thumbImage: file.thumb80,
      thumbFileIndex: index,
      entryNumber: currentEntry.number,
      contestName: contest.name });
  });

  initializeSlider();
}

function updateEntryDisplayer(newEntryFile) {
  if (newEntryFile.format !== FILE_FORMAT_VIDEO) {
    destroyVideoDisplayerIfExists();
  }

  switch (newEntryFile.format) {
    case FILE_FORMAT_IMAGE:
      displayImageFile(newEntryFile);
      break;
    case FILE_FORMAT_VIDEO:
      displayVideoFile(newEntryFile);
      break;
    case FILE_FORMAT_TEXT:
      displayTextFile(newEntryFile);
      break;
    default:
      showErrorModal(translate(_templateObject17$1));

      break;}
}

function destroyVideoDisplayerIfExists() {
  var entryFileDisplayer = entryContainer.querySelector('[data-displayer]');
  var entryFileDisplayerName = entryFileDisplayer.getAttribute(FILE_DISPLAYER_ATTR);

  if (entryFileDisplayerName === VIDEO_DISPLAYER_NAME) {
    videojs('player').dispose();
  }
}

function displayVideoFile(entryFile) {
  showLoading();

  entryContainer.className = '';
  entryContainer.classList.add(ENTRY_CONTAINER_CLASS);
  entryContainer.classList.add(VIDEO_ENTRY_CONTAINER_CLASS);

  var pathFolders = entryFile.pathFile.split('/');

  var isEntryVideoPathFormatOld = pathFolders.length === 3;

  var videoFileSrc = '';

  if (isEntryVideoPathFormatOld) {
    videoFileSrc = entryFile.path + 'video';
  } else {
    videoFileSrc = '' + entryFile.path + entryFile.name.substring(0, entryFile.name.lastIndexOf('.'));
  }

  var videoFileDisplayer = entryContainer.querySelector('[' + FILE_DISPLAYER_ATTR + '="' + VIDEO_DISPLAYER_NAME + '"]');

  if (videoFileDisplayer) {
    var videoPlayer = videoFileDisplayer.getElementsByTagName('video')[0];

    videoPlayer.setAttribute('src', videoFileSrc + '.mp4');

    var videoPlaceholderImgContainer = videoFileDisplayer.getElementsByClassName('vjs-poster')[0];

    if (videoPlaceholderImgContainer) {
      videoPlaceholderImgContainer.style.backgroundImage = 'url("' + entryFile.thumb420 + '")';
    }
  } else {
    (function () {
      entryContainer.innerHTML = compiledVideoEntryTemplate({
        videoPosterSrc: entryFile.thumb420,
        videoMp4Src: videoFileSrc + '.mp4',
        videoWebMSrc: videoFileSrc + '.webm' });

      var player = videojs('player', { controls: true }, function () {
        player.on('fullscreenchange', function () {
          document.classList.toggle('video-fullscreen');
        });
      });
    })();
  }
  hideLoading();
}

function displayTextFile(entryFile) {
  showLoading();

  entryContainer.className = '';
  entryContainer.classList.add(ENTRY_CONTAINER_CLASS);
  entryContainer.classList.add(TEXT_ENTRY_CONTAINER_CLASS);

  var textFileSrc = '' + VIEWER_SOURCE + entryFile.pathFile + '/' + entryFile.name;

  var textFileDisplayer = entryContainer.querySelector('[' + FILE_DISPLAYER_ATTR + '="' + TEXT_DISPLAYER_NAME + '"]');

  var iframe = null;

  if (textFileDisplayer) {
    iframe = entryContainer.querySelector('[data-hook="textFileIFrame"]');

    if (iframe) {
      iframe.setAttribute('src', textFileSrc);
    }
  }

  if (!textFileDisplayer || textFileDisplayer && !iframe) {
    entryContainer.innerHTML = compiledTextEntryTemplate({
      iframeSrc: textFileSrc });

    iframe = entryContainer.querySelector('[data-hook="textFileIFrame"]');
  }

  iframe.addEventListener('load', function () {
    var iframeWindow = iframe.contentWindow;
    var iframeDocument = iframe.contentDocument || iframeWindow.document;

    var toolbarContainer = iframeDocument.getElementById('toolbarContainer');

    toolbarContainer.classList.add('viewer-touched');
    hideLoading();
  });
}

function bindThumbnailEvents() {
  var carouselItems = Array.from(carouselThumbs.getElementsByTagName('img'));

  carouselItems.forEach(function (el) {
    el.addEventListener('click', function (event) {
      var selectedFileIndex = event.target.getAttribute('data-file-index');
      var selectedFile = currentEntry.files[selectedFileIndex];
      updateEntryDisplayer(selectedFile);
    });
  });
}

function navigate(entryId) {
  allowNavigation = false;
  removeHideClass(loaderEl);

  entryApi$1.getEntryInfo({
    project_id: contest.id,
    entry_id: entryId,
    sort: 'sort_default',
    filter: 'filter_open' }).then(function (response) {
    if (!response.vars) {
      showErrorModal(translate('Impossibile recuperare la proposta.'));
      return;
    }

    setEntryToPage(response.vars);
  }).then(function () {
    addHideClass(loaderEl);
    allowNavigation = true;
  });
}

function setEntryToPage(entryData) {
  var rating = parseInt(entryData.entry.rating, 10).toFixed(1);

  currentEntry = entryData.entry;
  nextEntry = entryData.nextEntry;
  prevEntry = entryData.prevEntry;
  isCurrentEntryLiked = entryData.currentUserIsFan;
  isLikeRestricted = entryData.restrictLike;
  updateEntryDetails(entryData.showEntry);
  updateMessageBoard();
  updateShareLinks(entryData.entry);
  updateEntryState(entryData);
  updateSellPrice();

  updateEntryThumbnails();

  updateArrowLinks();

  updateEntryDisplayer(currentEntry.files[0]);

  bindThumbnailEvents();
  setLikes();

  window.history.pushState(null, null, entry.seoURL);

  if (contest.isContestHolder) {
    initRating(rating);
  } else {
    entryRatingEl.setAttribute('data-star_rating', rating);
  }

  entryNumberEl.innerHTML = translate(_templateObject5$2, currentEntry.number);
}

function showLoading() {
  entryContainer.classList.add(LOADING_PLACEHOLDER_CLASS);
  loadingSpinner.classList.remove(HIDDEN_ELEMENT_CLASS);
}

function hideLoading() {
  entryContainer.classList.remove(LOADING_PLACEHOLDER_CLASS);
  loadingSpinner.classList.add(HIDDEN_ELEMENT_CLASS);
}
